export default {
  en: {
    identityVerified: 'Identity Verified',
    emailVerified: 'Email Verified',
    mobileVerified: 'Mobile Verified',
    addressVerified: 'Address Verified',
    accountLocked: 'Account Locked',
    locked: 'Locked',
    accountInactive: 'Account Inactive',
    blockedForMessages: 'Blocked for Messages',
    closed: 'Closed',
    inactiveAccount: 'Inactive Account',
    accountInTimeout: 'Account in Time-out',
    accountSelfExcluded: 'Account Self-Excluded',
    exclusionState: 'Exclusion State',
    physicalVerification: 'Physical Verification',
    blacklisted: 'Blacklisted',
    regDate: 'Reg. Date',
    regIP: 'Reg. IP',
    emailNotifications: 'Email Notifications',
    SMSNotifications: 'SMS Notifications',
    accountType: 'Account Type',
    accountUsers: 'Account Users',
    lastProvisionDate: 'Last Provision Date',
    lastAdjustmentDate: 'Last Adjustment Date',
    currencyDeletedOrDisabledTooltip: 'Account currency may have been disabled/deleted',
    adjustBalance: 'Adjust Balance',
    finishUse: 'Finish Use',
    closedAccountNote: 'Account will get closed and will no longer be available.',
    freeAccountNote: 'Account will become free for use.',
    testAccountDetails: 'Test Account Details',
    userDetails: 'User Details',
    accountUser: 'Account User',
    userEmail: 'User Email',
    userEmailTooltip: "Account's credentials will be sent to the provided email",
    adjust: 'Adjust',
    moneyTransferred: 'Money Transferred',
    moneyUsed: 'Money Used',
    provisionDate: 'Provision Date',
    providedBy: 'Provided By',
    attachmentId: 'Attachment ID',
    startProcess: 'Start Process',
    manageFiles: 'Manage Files',
    blockControl: 'Block Control',
    unblockMessages: 'Unblock Messages',
    investigationResults: 'Investigation Results',
    noAvailableAccountInfo: 'Account will no longer be available for use.',
    lComplete: 'complete',
    lIncomplete: 'incomplete',
    accountVerificationProgress: 'Account Verification Progress',
    newslettersAndPromotions: 'Newsletters and Promotions',
    betLimit: {
      modalTitle: 'Set Bet Limit',
      name: 'Bet Limit',
      description: 'Control the money player spends on gambling',
      buttonText: 'Set Limit',
    },
    withdrawalLimit: {
      modalTitle: 'Set Withdrawal Limit',
      name: 'Withdrawal Limit',
      description: 'Control the money player withdraws',
      buttonText: 'Set Limit',
    },
    depositLimit: {
      modalTitle: 'Set Deposit Limit',
      name: 'Deposit Limit',
      description: 'Control the money player deposits for gambling',
      buttonText: 'Set Limit',
    },
    timeOutLimit: {
      modalTitle: 'Set Time-Out',
      name: 'Time-Out',
      description: 'Give a short break to player from all gambling activities',
      buttonText: 'Set Time-Out',
    },
    selfExclusionLimit: {
      modalTitle: 'Set Exclusion',
      name: 'Self-Exclusion',
      description: 'Exclude player from all gambling activities to stay in control',
      buttonText: 'Set Exclusion',
    },
    realityCheckLimit: {
      modalTitle: 'Set Check',
      name: 'Reality Check',
      description: 'Remind the player spent on the platform',
      buttonText: 'Set Check',
    },
    accessLimit: {
      modalTitle: 'Set Access Limit',
      name: 'Access Limit',
      description: 'Limit the player access to the website',
      buttonText: 'Set Limit',
    },
    lossLimit: {
      modalTitle: 'Set Loss Limit',
      name: 'Loss Limit',
      description: 'Controls the money player loses while gambling',
      buttonText: 'Set Limit',
    },
    singleBetLimit: {
      modalTitle: 'Set Single Bet Limit',
      name: 'Single Bet Limit',
      description: 'Controls the maximum single  stake amount player can bet',
      buttonText: 'Set Limit',
    },
    gameTimeLimit: {
      modalTitle: 'Set Game Time Limit',
      name: 'Game Time Limit',
      description: 'Controls the time spent on RNG Games.',
      buttonText: 'Set Limit',
    },
    netDepositLimit: {
      modalTitle: 'Set Net Deposit Limit',
      name: 'Net Deposit Limit',
      description: 'Control the money player net deposit for gambling',
      buttonText: 'Set Limit',
    },
    noLimit: 'No Limit',
    current: 'Current',
    remainder: 'Remainder',
    upcomingChanges: 'Upcoming Changes',
    limitType: 'Limit Type',
    endOfLimitation: 'End of Limitation',
    appliedBy: 'Applied By',
    exportNoteInfo: 'Up to 6 months data will be exported.',
    accountStatusBeforeClosure: 'Account Status Before Closure',
    accountRegistrationDate: 'Account Registration Date',
    accountClosureDate: 'Account Closure Date',
    reasonOfClosure: 'Reason Of Closure',
    matchingCriteria: 'Matching Criteria',
    dateAgreed: 'Date Agreed',
    test: 'Test',
    personalInformation: 'Personal Information',
    walletInformation: 'Wallet Information',
    countryCity: 'Country, City',
    mobile: 'Mobile',
    documents: 'Documents',
    pendingFileGroups: 'Pending File Groups',
    verifiedWith: 'Verified With',
    uploadAsApproved: 'Upload as Approved',
    archive: 'Archive',
    unverifyPlayerIdentity: "Unverify player's identity",
    unverifyPlayerAddress: "Unverify player's address",
    fileNameAndExtension: 'File Name and Extension',
    approvedBy: 'Approved By',
    notBlacklisted: 'Not Blacklisted',
    statusBefore: 'Status Before',
    statusAfter: 'Status After',
    currentStatus: 'Current Status',
    playersWithMissingInfo: 'Players with missing info',
    verifyDocumentInfo: 'Make sure that all the approved documents contain complete information before verification.',
    notes: 'Notes',
    markAttention: 'Mark Attention',
    playerSession: 'Player session',
    playerBalance: 'Player balance',
    playersBalance: "Players' balances",
    testPlayersAccount: "Test player's account",
    accountUsersInformation: "Account user's information",
    process: 'Process',
    attentionLevel: 'Attention Level',
    playerNotes: 'Player Notes',
    cards: 'Cards',
    sessionStart: 'Session Start',
    sessionEnd: 'Session End',
    sessionEndReason: 'Session End Reason',
    walletTransactionId: 'Wallet TXN ID',
    realWalletAfter: 'Real Wallet After',
    sumRealWallets: 'Sum Real Wallets',
    actionLogs: 'Action Logs',
    day1HoursLimitAmount: '24 Hours Limit Amount',
    days7LimitAmount: '7 Days Limit Amount',
    month1LimitAmount: '1 Month Limit Amount',
    selectedProviders: 'Selected Providers',
    countryOfCitizenship: 'Country Of Citizenship',
    lCountryOfCitizenship: 'country of citizenship',
    citizenshipVerified: 'Citizenship Verified',
    blockedProvidersList: 'Blocked Providers list',
    blockedProviders: 'Blocked Providers',
    lastDeposit: 'Last Deposit',
    lastWithdrawal: 'Last Withdrawal',
    last24hDeposits: 'Deposits within the last 24h',
    last24hWithdrawals: 'Withdrawals within the last 24h',
    takenMonthData: 'Only data from the last {{count}} months is taken into account',
    method: 'Method',
    playerActivities: 'Player Activities',
    lastLoginInfo: 'Last Login Info',
    registrationInfo: 'Registration Info',
    responsibleGamingLimits: 'Responsible Gaming Limits',
    p2pGgr: 'P2P GGR',
    similarAccountsInfo: 'Here we can see account filtering during the last 6 months with these criteria: {{criteria1}} and {{criteria2}}',
    pep: 'PEP',
    verticalCategoryNoReasonInfo: 'Please activate the reasons for this category or edit the reasons requirement from the category',
    clickToSeePendingFiles: 'Click on the icon to see pending files',
    repetitionPeriod: 'Repetition Period',
    subAffiliateId: ' Sub Affiliate ID',
    repetitionDate: 'Repetition Date',
    approvalDate: 'Approval Date',
    debtWallet: 'Debt Wallet',
    personalNumericCode: 'Personal Numeric Code',
    personalNumericCodeNote: 'If checked, Personal Numeric Code field is added to the Document Verification flow, can be verified with Document and is available in different reports.',
    brandRealityCheckLimitInfo: 'The limit is configured for all brand players, and it is not possible to change the limit for the player individually',
    externalPlayerId: 'External Player ID',
    documentDescriptionInfo: 'Please describe the meaning of the document',
    realWalletBefore: 'Real Wallet Before',
    resetPassword: 'Reset Password',
    PlayerMobileNumberInUse: 'A player with this phone number already exists',
    PlayerEmailInUse: 'A player with this email address already exists',
    cpfNumber: 'CPF Number',
    disableTFA: 'Disable 2FA',
    tFA: '2FA',
    missingFieldsInAttachmentsInfo: 'The required data for approving this document has not been filled',
    year1LimitAmount: '1 Year Limit Amount',
    pushNotification: 'Push Notification',
    indicators: 'Indicators',
    turnover: 'Turnover',
    totalNetBalance: 'Total Net Balance',
    extraWallets: 'Extra Wallets',
    tillDate: 'Till Date',
    tillDateInfo: 'Till Date can be selected at least seven days after the present date',
    currentType: 'Current Type',
    upcomingType: 'Upcoming Type',
    upcomingDate: 'Upcoming Date',
    editAccessLimit: 'Edit Access Limit',
    weekDays: 'Weekdays',
    inactivePeriodTime: 'Inactive Period Time',
    setBy: 'Set by',
    effectDate: 'Effect Date',
    accessLimitTimezoneInfo: 'The Access Limit will work with brand default timezone: {{timezone}}',
    upcoming: 'Upcoming',
    viewAccessLimit: 'View Access Limit',
    cpfNumberVerified: 'CPF Verified',
    deposit: 'Deposit',
    withdrawal: 'Withdrawal',
    smsPreferencesDescription: 'Select the events for which the player will receive SMS notifications.',
    emailPreferencesDescription: 'Select the events for which the player will receive Email notifications.',
    pushPreferencesDescription: 'Select the events for which the player will receive Push Notifications.',
    blockedPayments: 'Blocked Payments',
    blockPayments: 'Block Payments',
    unblockPayments: 'Unblock Payments',
    endSessions: 'End Sessions',
    showLastLoginInfo: 'Show Last Login Info',
    showLastLoginInfoNote: 'By enabling the player will see the last login information on the website.',
    day1HoursTimeLimit: '24 Hours Time Limit',
    days7TimeLimit: '7 Days Time Limit',
    month1TimeLimit: '1 Month Time Limit',
    year1TimeLimit: '1 Year Time Limit',
    noExpiry: 'No Expiry',
    documentNoExpiryDateInfo: 'By enabling this, the document will not have an expiration date.',
    taxSessionID: 'Tax Session ID',
    taxSessionStart: 'Tax Session Start',
    taxSessionEnd: 'Tax Session End',
    blockedDepositUntil: 'Blocked Deposit until {{date}}',
    blockedWithdrawalUntil: 'Blocked Withdrawal until {{date}}',
    paymentVerified: 'Payment Verified',
    fullVerified: 'Full Verified',
    allowedAttachmentsCountInfo: 'For selected document type should be uploaded <0>{{count}}</0> attachment(s). Sum: <0>{{maxFileSize}}MB</0>. Ext: <0>{{extensions}}</0>.',
    dailyLimitAmount: 'Daily Limit Amount',
    weeklyLimitAmount: 'Weekly Limit Amount',
    monthlyLimitAmount: 'Monthly Limit Amount',
    annualLimitAmount: 'Annual Limit Amount',
    eddVerified: 'Edd Verified',
    enhancedDueDiligence: 'Enhanced Due Diligence',
    legacyData: 'Legacy Data',
    dailyLimit: 'Daily Limit',
    day1HoursLimit: '24 Hours Limit',
    weeklyLimit: 'Weekly Limit',
    days7Limit: '7 Days Limit',
    monthlyLimit: 'Monthly Limit',
    month1Limit: '1 Month Limit',
    annualLimit: 'Annual Limit',
    year1Limit: '1 Year Limit',
    dateOfBirthDate: 'DoB: Date',
    dateOfBirthMonth: 'DoB: Month',
    personal: 'Personal',
    wallet: 'Wallet',
    docs: 'Docs',
    changeLayout: 'Change Layout',
    top: 'Top',
    left: 'Left',
    right: 'Right',
    accumulatedTax: 'Accumulated Tax',
    numberOfLevel: 'Level {{number}}',
    sportOpenBets: 'Sport Open Bets',
    unblockPayment: 'Unblock Payment',
    otp: 'OTP',
    setOTP: 'Set OTP',
    setPlayerOTPInfo: 'The OTP stays visible until the player changes his password and is then automatically removed. You can generate a new OTP at any time if needed.',
    oneTimePassword: 'One-Time Password',
    generate: 'Generate',
    regenerate: 'Regenerate',
    addNewNote: 'Add New Note',
    lastTrigger24HoursLimitAmount: 'Last Trigger 24 Hours Limit Amount',
    lastTrigger7DaysLimitAmount: 'Last Trigger 7 Days Limit Amount',
    lastTrigger1MonthLimitAmount: 'Last Trigger 1 Month Limit Amount',
    lastTrigger1YearLimitAmount: 'Last Trigger 1 Year Limit Amount',
    paydromAccount: 'Paydrom Account',
    episServersDownInfo: 'EPIS servers are not responding',
    placeOfIssue: 'Place of Issue',
    choosePlaceOfIssue: 'Choose Place of Issue',
    months: 'Months',
    episVerified: 'EPIS Verified',
    episNotVerified: 'EPIS Not Verified',
    rutNumber: 'RUT Number',
    reasonInfo: 'Visible only to internal users on the platform',
    commentInfo: 'Visible to the player on the website and to internal users on the platform.',
    online: 'Online',
    mainInformation: 'Main Information',
    accountStatuses: 'Account Statuses',
    walletHistory: 'Wallet History',
    curp: 'CURP',
    blockActivities: 'Block Activities',
    unblockActivities: 'Unblock Activities',
    blockForUnVerified: 'Block for Unverified',
    blockForUnVerifiedInfo: 'The following activities will be restricted according to configuration:',
    activities: 'Activities',
    addPlayerToBlacklist: 'Add Player to Blacklist',
    removePlayerFromBlacklist: 'Remove Player from Blacklist',
    blacklistInfo: 'These restrictions cannot be removed one by one while the player remains blacklisted. To restore player access, the player must first be removed from the blacklist.',
    netDepositInfo: 'Net Deposit = total successful deposits - total successful withdrawals over the selected period.',
    lifeTime: 'Lifetime',
    amlCheckResponse: 'AML Check Response',
    gamStopExcluded: 'Gamstop Excluded',
    promotionDescription: 'Select the channels through which the player will receive Newsletters and Promotions notifications.',
    bonusesDescription: 'Select the channels through which the player will receive Bonuses and Cashback notifications.',
    depositDescription: 'Select the channels through which the player will receive Deposit notifications.',
    withdrawalDescription: 'Select the channels through which the player will receive Withdrawal notifications.',
    blocked: 'Blocked',
    removing: 'Removing',
    nraRestricted: 'NRA Restricted',
    documentDetails: 'Document Details',
    playerDetails: 'Player Details',
    roundIdCouponNumberInfo: 'Identifies the source associated with the transaction, such as a Coupon Number & Round ID',
  },
  es: {
    identityVerified: 'Identidad verificada',
    emailVerified: 'Correo electrónico verificado',
    mobileVerified: 'Móvil verificado',
    addressVerified: 'Dirección verificada',
    accountLocked: 'Cuenta bloqueada',
    locked: 'Bloqueada',
    accountInactive: 'Cuenta inactiva',
    blockedForMessages: 'Bloquedada para mensajes',
    closed: 'Cerrada',
    inactiveAccount: 'Cuenta inactiva',
    accountInTimeout: 'Cuenta en tiempo muerto',
    accountSelfExcluded: 'Cuenta autoexcluida',
    exclusionState: 'Estado de exclusión',
    physicalVerification: 'Verificación física',
    blacklisted: 'Incluido en la lista de no admitidos',
    regDate: 'Fecha de reg.',
    regIP: 'IP de reg.',
    emailNotifications: 'Notificaciones por correo electrónico',
    SMSNotifications: 'Notificaciones por SMS',
    accountType: 'Tipo de cuenta',
    accountUsers: 'Usuarios de la cuenta',
    lastProvisionDate: 'Fecha de última oferta',
    lastAdjustmentDate: 'Fecha de último ajuste',
    currencyDeletedOrDisabledTooltip: 'La moneda de la cuenta puede haber sido desactivada/borrada',
    adjustBalance: 'Ajustar saldo',
    finishUse: 'Uso de la terminación',
    closedAccountNote: 'La cuenta se cerrará y dejará de estar disponible.',
    freeAccountNote: 'La cuenta pasará a ser de uso gratuito.',
    testAccountDetails: 'Datos de la cuenta de prueba',
    userDetails: 'Datos del usuario',
    accountUser: 'Usuario de la cuenta',
    userEmail: 'Correo electrónico del usuario',
    userEmailTooltip: 'Las credenciales de la cuenta se enviarán al correo electrónico proporcionado',
    adjust: 'Ajustar',
    moneyTransferred: 'Dinero transferido',
    moneyUsed: 'Dinero transferido',
    provisionDate: 'Fecha de la oferta',
    providedBy: 'Proporcionado por',
    attachmentId: 'ID del anexo',
    startProcess: 'Iniciar proceso',
    manageFiles: 'Gestionar archivos',
    blockControl: 'Bloquear control',
    unblockMessages: 'Desbloquear mensajes',
    investigationResults: 'Resultados de la investigación',
    noAvailableAccountInfo: 'La cuenta dejará de estar disponible para su uso',
    lComplete: 'completo',
    lIncomplete: 'incompleto',
    accountVerificationProgress: 'Progreso de la verificación de cuenta',
    newslettersAndPromotions: 'Boletines y promociones',
    betLimit: {
      modalTitle: 'Fijar límite de apuesta',
      name: 'Límite de apuesta',
      description: 'Controlar el dinero que el jugador gasta en el juego',
      buttonText: 'Fijar límite',
    },
    withdrawalLimit: {
      modalTitle: 'Fijar límite de retiro',
      name: 'Límite de retiro',
      description: 'Controlar el dinero que el jugador retira',
      buttonText: 'Fijar límite',
    },
    depositLimit: {
      modalTitle: 'Fijar límite de depósito',
      name: 'Depositar límite',
      description: 'Controlar el dinero que el jugador deposita para jugar',
      buttonText: 'Fijar límite',
    },
    timeOutLimit: {
      modalTitle: 'Fijar tiempo muerto',
      name: 'Tiempo muerto',
      description: 'Dar una pequeña pausa al jugador de todas las actividades de juego',
      buttonText: 'Fijar tiempo muerto',
    },
    selfExclusionLimit: {
      modalTitle: 'Fijar exclusión',
      name: 'Autoexclusión',
      description: 'Excluir al jugador de todas las actividades de juego para que conserve el control',
      buttonText: 'Fijar exclusión',
    },
    realityCheckLimit: {
      modalTitle: 'Configurar Control',
      name: 'Control de Realidad',
      description: 'Recordar al jugador el tiempo que ha pasado en la plataforma.',
      buttonText: 'Establecer Control',
    },
    accessLimit: {
      modalTitle: 'Establecer Límite de Acceso',
      name: 'Límite de Acceso',
      description: 'Restringe el acceso del jugador al sitio web.',
      buttonText: 'Establecer Límite',
    },
    lossLimit: {
      modalTitle: 'Establecer Límite de Pérdida',
      name: 'Límite de Pérdida',
      description: 'Controla la cantidad de dinero que el jugador puede perder mientras juega.',
      buttonText: 'Establecer Límite',
    },
    singleBetLimit: {
      modalTitle: 'Establecer Límite de Apuesta Única',
      name: 'Límite de Apuesta Única',
      description: 'Controla el monto máximo que el jugador puede apostar en una sola apuesta.',
      buttonText: 'Establecer Límite',
    },
    gameTimeLimit: {
      modalTitle: 'Establecer Límite de Tiempo de Juego',
      name: 'Límite de Tiempo de Juego',
      description: 'Controla el tiempo que el jugador pasa en Juegos RNG.',
      buttonText: 'Establecer Límite',
    },
    noLimit: 'Sin límite',
    current: 'Actual',
    remainder: 'Resto',
    upcomingChanges: 'Próximos cambios',
    limitType: 'Tipo de límite',
    endOfLimitation: 'Fin de la limitación',
    appliedBy: 'Aplicado por',
    exportNoteInfo: 'Se exportarán los datos de hasta 6 meses.',
    accountStatusBeforeClosure: 'Estado de la cuenta antes del cierre',
    accountRegistrationDate: 'Fecha de registro de la cuenta',
    accountClosureDate: 'Fecha de cierre de la cuenta',
    reasonOfClosure: 'Motivo del cierre',
    matchingCriteria: 'Criterios de concordancia',
    dateAgreed: 'Fecha acordada',
    test: 'Test',
    personalInformation: 'Información personal',
    walletInformation: 'Información del monedero',
    countryCity: 'País, ciudad',
    mobile: 'Móvil',
    documents: 'Documentos',
    pendingFileGroups: 'Grupos de archivos pendientes',
    verifiedWith: 'Verificar con',
    uploadAsApproved: 'Cargar como aprobado',
    archive: 'Archivo',
    unverifyPlayerIdentity: 'Sin verificar la identidad del jugador',
    unverifyPlayerAddress: 'Sin verificar la dirección del jugador',
    fileNameAndExtension: 'Nombre y extensión del archivo',
    approvedBy: 'Aprobado por',
    notBlacklisted: 'No está en la lista de no admitidos',
    statusBefore: 'Estado previo',
    statusAfter: 'Estado posterior',
    currentStatus: 'Estado actual',
    playersWithMissingInfo: 'Jugadores sin info. completa',
    verifyDocumentInfo: 'Asegúrese de que todos los documentos aprobados contienen información completa antes de la verificación.',
    notes: 'Notas',
    markAttention: 'Atención a la marca',
    playerSession: 'Sesión del jugador',
    playerBalance: 'Saldo del jugador',
    playersBalance: 'Saldos de los jugadores',
    testPlayersAccount: 'Cuenta del jugador de prueba',
    accountUsersInformation: 'Información del usuario de la cuenta',
    process: 'Proceso',
    attentionLevel: 'Nivel de antención',
    playerNotes: 'Notas del jugador',
    cards: 'Cartas',
    sessionId: 'ID de sesión',
    sessionStart: 'Inicio de sesión',
    sessionEnd: 'Fin de sesión',
    sessionEndReason: 'Motivo del fin de sesión',
    walletTransactionId: 'ID de transacción del monedero',
    realWalletAfter: 'Monedero real posterior',
    sumRealWallets: 'Suma de monederos reales',
    actionLogs: 'Registros de acción',
    day1HoursLimitAmount: 'Importe límite de 24 horas',
    days7LimitAmount: 'Importe límite de 7 días',
    month1LimitAmount: 'Importe límite de 1 mes',
    lastDeposit: 'Último Depósito',
    takenMonthData: 'Solamente se tienen en cuenta los datos de los últimos {{count}} meses',
    method: 'Método',
    lastWithdrawal: 'Última Retirada',
    last24hDeposits: 'Depósitos en las últimas 24 horas',
    last24hWithdrawals: 'Retiradas en las últimas 24 horas',
    playerActivities: 'Actividades del jugador',
    lastLoginInfo: 'Información de la última conexión',
    registrationInfo: 'Información de registro',
    blockedProviders: 'Proveedores bloqueados',
    selectedProviders: 'Proveedores seleccionados',
    countryOfCitizenship: 'País de nacionalidad',
    lCountryOfCitizenship: 'País de nacionalidad',
    citizenshipVerified: 'Nacionalidad verificada',
    blockProviders: 'Proveedores de bloques',
    blockedProvidersList: 'Lista de proveedores bloqueados',
    responsibleGamingLimits: 'Límites del juego responsable',
    p2pGgr: 'P2P GGR',
    pep: 'PEP',
    verticalCategoryNoReasonInfo: 'Por favor, active los motivos de esta categoría o edite el requisito de los motivos de la categoría',
    clickToSeePendingFiles: 'Haga clic en el icono para ver los expedientes pendientes',
    repetitionPeriod: 'Periodo de Repetición',
    subAffiliateId: 'ID de Subafiliado',
    repetitionDate: 'Fecha de Repetición',
    approvalDate: 'Fecha de Aprobación',
    debtWallet: 'Cartera de Deudas',
    personalNumericCode: 'Código Numérico Personal',
    personalNumericCodeNote:
      'Si se marca, se añade el campo de Código Numérico Personal al flujo de Verificación de Documentos, puede ser verificado con el documento y está disponible en diferentes informes.',
    brandRealityCheckLimitInfo: 'El límite está configurado para todos los jugadores de la marca y no es posible cambiar el límite individualmente para el jugador.',
    externalPlayerId: 'ID de Jugador Externo',
    documentDescriptionInfo: 'Por favor, describe el significado del documento.',
    realWalletBefore: 'Anterior a la Cartera Real',
    resetPassword: 'Restablecer Contraseña',
    PlayerMobileNumberInUse: 'Ya existe un jugador con este número de teléfono.',
    PlayerEmailInUse: 'Ya existe un jugador con este E-mail',
    cpfNumber: 'Número de CPF',
    disableTFA: 'Desactivar 2FA',
    tFA: '2FA',
    missingFieldsInAttachmentsInfo: 'Los datos necesarios para aprobar este documento no han sido completados.',
    year1LimitAmount: 'Importe de Límite de 1 Año',
    pushNotification: 'Notificación Push',
    indicators: 'Indicadores',
    turnover: 'Turnover',
    totalNetBalance: 'Balance Neto Total',
    extraWallets: 'Cartera Adicional',
    tillDate: 'Hasta la Fecha',
    tillDateInfo: 'Hasta la Fecha se puede seleccionar al menos siete días después de la fecha actual.',
    currentType: 'Tipo Actual',
    upcomingType: 'Tipo Próximo',
    upcomingDate: 'Fecha Próxima',
    editAccessLimit: 'Editar Límite de Acceso',
    weekDays: 'Días de la Semana',
    inactivePeriodTime: 'Tiempo de Período Inactivo',
    setBy: 'Establecido por',
    effectDate: 'Fecha de Efecto',
    accessLimitTimezoneInfo: 'El Límite de Acceso funcionará con la zona horaria predeterminada de la marca: {{timezone}}',
    upcoming: 'Próximo',
    viewAccessLimit: 'Ver Límite de Acceso',
    cpfNumberVerified: 'CPF Verificado',
    deposit: 'Depósito',
    withdrawal: 'Retiro',
    smsPreferencesDescription: 'Selecciona los eventos para los cuales el jugador recibirá notificaciones SMS',
    emailPreferencesDescription: 'Selecciona los eventos para los cuales el jugador recibirá notificaciones por correo electrónico.',
    pushPreferencesDescription: 'Selecciona los eventos para los cuales el jugador recibirá Notificaciones Push',
    blockedPayments: 'Pagos Bloqueados',
    blockPayments: 'Bloquear Pagos',
    unblockPayments: 'Desbloquear Pagos',
    endSessions: 'Finalizar Sesiones',
    showLastLoginInfo: 'Mostrar Última Información de Inicio de Sesión',
    showLastLoginInfoNote: 'Al habilitar esta opción, el jugador verá la información del último inicio de sesión en el sitio web.',
    day1HoursTimeLimit: 'Límite de Tiempo de 24 Horas',
    days7TimeLimit: 'Límite de Tiempo de 7 Días',
    month1TimeLimit: 'Límite de Tiempo de 1 Mes',
    year1TimeLimit: 'Límite de Tiempo de 1 Año',
    noExpiry: 'Sin Fecha de Expiración',
    documentNoExpiryDateInfo: 'Al habilitar esta opción, el documento no tendrá una fecha de expiración.',
    taxSessionID: 'ID de Sesión Fiscal',
    taxSessionStart: 'Inicio de Sesión Fiscal',
    taxSessionEnd: 'Fin de Sesión Fiscal',
    blockedDepositUntil: 'Depósitos Bloqueados hasta {{date}}',
    blockedWithdrawalUntil: 'Retiros Bloqueados hasta {{date}}',
    paymentVerified: 'Pago Verificado',
    fullVerified: 'Verificación Completa',
    allowedAttachmentsCountInfo: 'Para el tipo de documento seleccionado, se debe(n) cargar {{count}} archivo(s) adjunto(s).',
    dailyLimitAmount: 'Límite Diario de Monto',
    weeklyLimitAmount: 'Límite Semanal de Monto',
    monthlyLimitAmount: 'Límite Mensual de Monto',
    annualLimitAmount: 'Límite Anual de Monto',
    eddVerified: 'EDD Verificado',
    enhancedDueDiligence: 'Debida Diligencia Reforzada',
    setOTP: 'Establecer OTP',
    setPlayerOTPInfo: 'El OTP permanece visible hasta que el jugador cambie su contraseña y luego se elimina automáticamente. Puedes generar un nuevo OTP en cualquier momento si es necesario.',
    oneTimePassword: 'Contraseña de un solo uso',
    legacyData: 'Datos heredados',
    dailyLimit: 'Límite diario',
    day1HoursLimit: 'Límite de 24 horas',
    weeklyLimit: 'Límite semanal',
    days7Limit: 'Límite de 7 días',
    monthlyLimit: 'Límite mensual',
    month1Limit: 'Límite de 1 mes',
    annualLimit: 'Límite anual',
    year1Limit: 'Límite de 1 año',
    dateOfBirthDate: 'Fecha de nacimiento: Día',
    dateOfBirthMonth: 'Fecha de nacimiento: Mes',
    personal: 'Personal',
    wallet: 'Wallet',
    docs: 'Documentos',
    changeLayout: 'Cambiar diseño',
    top: 'Arriba',
    left: 'Izquierda',
    right: 'Derecha',
    accumulatedTax: 'Impuesto acumulado',
    numberOfLevel: 'Nivel {{number}}',
    sportOpenBets: 'Apuestas deportivas abiertas',
    unblockPayment: 'Desbloquear pago',
    otp: 'OTP',
    generate: 'Generar',
    regenerate: 'Regenerar',
    addNewNote: 'Añadir nueva nota',
    lastTrigger24HoursLimitAmount: 'Importe del límite del último trigger en 24 horas',
    lastTrigger7DaysLimitAmount: 'Importe del límite del último trigger en 7 días',
    lastTrigger1MonthLimitAmount: 'Importe del límite del último trigger en 1 mes',
    lastTrigger1YearLimitAmount: 'Importe del límite del último trigger en 1 año',
    paydromAccount: 'Cuenta de Paydrom',
    episServersDownInfo: 'Los servidores de EPIS no están respondiendo',
    placeOfIssue: 'Lugar de emisión',
    choosePlaceOfIssue: 'Elegir lugar de emisión',
    months: 'Meses',
    episVerified: 'Verificado por EPIS',
    episNotVerified: 'No verificado por EPIS',
    rutNumber: 'Número de RUT',
  },
  tr: {
    identityVerified: 'Kimlik Doğrulandı',
    emailVerified: 'E-posta Doğrulandı',
    mobileVerified: 'Cep Telefonu Doğrulandı',
    addressVerified: 'Adres Doğrulandı',
    accountLocked: 'Hesap Kilitli',
    locked: 'Kilitli',
    accountInactive: 'Hesap Aktif Değil',
    blockedForMessages: 'Mesajlar için Engellendi',
    closed: 'Kapalı',
    inactiveAccount: 'Aktif Olmayan Hesap',
    accountInTimeout: 'Hesap Kısıtlandı',
    accountSelfExcluded: 'Hesap Kendini Hariç Tutuyor',
    exclusionState: 'Hariç Tutma Durumu',
    physicalVerification: 'Fiziksel Doğrulama',
    blacklisted: 'Kara listede',
    regDate: 'Kayıt Tarihi',
    regIP: 'Kayıt IP',
    emailNotifications: 'E-posta Bildirimleri',
    SMSNotifications: 'SMS Bildirimleri',
    accountType: 'Hesap Türü',
    accountUsers: 'Hesap Kullanıcıları',
    lastProvisionDate: 'Son Provizyon Tarihi',
    lastAdjustmentDate: 'Son Düzenleme Tarihi',
    currencyDeletedOrDisabledTooltip: 'Hesabın para birimi devre dışı bırakılmış/silinmiş olabilir',
    adjustBalance: 'Bakiyeyi Düzenle',
    finishUse: 'Kullanımı Bitir',
    closedAccountNote: 'Hesap kapatılır ve artık kullanılamaz.',
    freeAccountNote: 'Hesap kullanım için ücretsiz olacaktır.',
    testAccountDetails: 'Test Hesabı Bilgileri',
    userDetails: 'Kullanıcı Bilgileri',
    accountUser: 'Hesap Kullanıcısı',
    userEmail: 'Kullanıcı E-postası',
    userEmailTooltip: 'Hesabın giriş bilgileri sağlanan e-postaya gönderilecek',
    adjust: 'Düzenle',
    moneyTransferred: 'Transfer Edilen Para',
    moneyUsed: 'Kullanılan Para',
    provisionDate: 'Provizyon Tarihi',
    providedBy: 'Sağlayan',
    attachmentId: 'Ek Kimlik',
    startProcess: 'İşlemi Başlat',
    manageFiles: 'Dosyaları Yönet',
    blockControl: 'Engel Kontrolü',
    unblockMessages: 'Mesajların Engelini Kaldır',
    investigationResults: 'Soruşturma Sonuçları',
    noAvailableAccountInfo: 'Hesap artık kullanılamaz.',
    lComplete: 'tamamlandı',
    lIncomplete: 'tamamlanmadı',
    accountVerificationProgress: 'Hesap Doğrulaması İlerlemesi',
    newslettersAndPromotions: 'Haber Bültenleri ve Promosyonlar',
    betLimit: {
      modalTitle: 'Bahis Limiti Belirle',
      name: 'Bahis Limiti',
      description: 'Oyuncunun bahis oynamaya harcadığı parayı kontrol edin',
      buttonText: 'Limit Belirle',
    },
    withdrawalLimit: {
      modalTitle: 'Para Çekme Limiti Belirle',
      name: 'Para Çekme Limiti',
      description: 'Oyuncunun çektiği parayı kontrol edin',
      buttonText: 'Limit Belirle',
    },
    depositLimit: {
      modalTitle: 'Para Yatırma Limiti Belirle',
      name: 'Para Yatırma Limiti',
      description: 'Oyuncunun bahis oynamak için yatırdığı parayı kontrol edin',
      buttonText: 'Limit Belirle',
    },
    timeOutLimit: {
      modalTitle: 'Kısıtlama Belirle',
      name: 'Kısıtlama',
      description: 'Oyuncuya bütün bahis oynama aktiviteleri konusunda kısa bir ara verin',
      buttonText: 'Kısıtlama Belirle',
    },
    selfExclusionLimit: {
      modalTitle: 'Hariç Tutmayı Belirle',
      name: 'Kendini Hariç Tutma',
      description: 'Kontrolü kaybetmemek için oyuncuyu bütün bahis oynama aktivitelerinden hariç tutun',
      buttonText: 'Hariç Tutmayı Ayarla',
    },
    realityCheckLimit: {
      modalTitle: 'Kontrolü Ayarla',
      name: 'Gerçeklik Kontrolü',
      description: 'Platformda harcama yapan oyuncuyu hatırlat',
      buttonText: 'Kontrolü Ayarla',
    },
    accessLimit: {
      modalTitle: 'Erişim Limitini Ayarla',
      name: 'Erişim Limiti',
      description: 'Oyuncunun web sitesine erişimini limitleyin',
      buttonText: 'Limit Ayarla',
    },
    lossLimit: {
      modalTitle: 'Kayıp Limiti Ayarla',
      name: 'Kayıp Limiti',
      description: 'Kumar oynarken oyuncunun kaybettiği parayı kontrol eder.',
      buttonText: 'Limit Ayarla',
    },
    singleBetLimit: {
      modalTitle: 'Tekli Bahis Limiti Ayarla',
      name: 'Tekli Bahis Limiti',
      description: 'Oyuncunun bahis yapabileceği maksimum tekli bahis tutarını kontrol eder.',
      buttonText: 'Limit Ayarla',
    },
    gameTimeLimit: {
      modalTitle: 'Oyun Süresi Limiti Ayarla',
      name: 'Oyun Süresi Limiti',
      description: 'RNG Oyunlarında geçirilen süreyi kontrol eder.',
      buttonText: 'Limit Ayarla',
    },
    noLimit: 'Limit yok',
    current: 'Mevcut',
    remainder: 'Kalan',
    upcomingChanges: 'Gelecek Değişiklikler',
    limitType: 'Limit Türü',
    endOfLimitation: 'Limit Sonu',
    appliedBy: 'Uygulayan',
    exportNoteInfo: 'En fazla 6 aylık veri dışa aktarılacaktır.',
    accountStatusBeforeClosure: 'Kapatılmadan Önce Hesap Durumu',
    accountRegistrationDate: 'Hesap Kayıt Tarihi',
    accountClosureDate: 'Hesap Kapatma Tarihi',
    reasonOfClosure: 'Kapatma Nedeni',
    matchingCriteria: 'Eşleşen Kriterler',
    dateAgreed: 'Kabul Edilme Tarihi',
    test: 'Test',
    personalInformation: 'Kişisel Bilgiler',
    walletInformation: 'Cüzdan Bilgileri',
    countryCity: 'Ülke, Şehir',
    mobile: 'Cep Telefonu',
    documents: 'Belgeler',
    pendingFileGroups: 'Bekleyen Dosya Grupları',
    verifiedWith: 'Doğrulama Metodu',
    uploadAsApproved: 'Onaylandı olarak yükle',
    archive: 'Arşivle',
    unverifyPlayerIdentity: 'Oyuncu kimliği doğrulamasını kaldır',
    unverifyPlayerAddress: 'Oyuncu adresi doğrulamasını kaldır',
    fileNameAndExtension: 'Dosya Adı ve Genişletme',
    approvedBy: 'Onaylayan',
    notBlacklisted: 'Kara Listede Değil',
    statusBefore: 'Önceki Durum',
    statusAfter: 'Sonraki Durum',
    currentStatus: 'Mevcut Durum',
    playersWithMissingInfo: 'Bilgileri eksik olan oyuncular',
    verifyDocumentInfo: 'Bütün onaylı belgelerin doğrulamadan önce tam bilgi içerdiğinden emin olun.',
    notes: 'Notlar',
    markAttention: 'Dikkat işareti koy',
    playerSession: 'Oyuncu oturumu',
    playerBalance: 'Oyuncu bakiyesi',
    playersBalance: 'Oyuncuların bakiyeleri',
    testPlayersAccount: 'Test oyuncusu hesabı',
    accountUsersInformation: 'Hesap kullanıcısı bilgileri',
    process: 'İşlem',
    attentionLevel: 'Dikkat Seviyesi',
    playerNotes: 'Oyuncu Notları',
    cards: 'Kartlar',
    sessionId: 'Oturum Kimliği',
    sessionStart: 'Oturum Başlangıcı',
    sessionEnd: 'Oturum Sonu',
    sessionEndReason: 'Oturum Sonu Nedeni',
    walletTransactionId: 'Cüzdan TXN Kimliği',
    realWalletAfter: 'Sonra Gerçek Cüzdan',
    sumRealWallets: 'Gerçek Cüzdanlar Toplamı',
    actionLogs: 'Eylem Günlükleri',
    day1HoursLimitAmount: '24 Saatlik Limit Miktarı',
    days7LimitAmount: '7 Günlük Limit Miktarı',
    month1LimitAmount: '1 Aylık Limit Miktarı',
    lastDeposit: 'Son Para Yatırımı',
    takenMonthData: 'Sadece son {{count}} aydaki veriler hesaba alınır.',
    method: 'Yöntem',
    lastWithdrawal: 'Son Para Çekimi',
    last24hDeposits: 'Son 24 saatteki para yatırımları',
    last24hWithdrawals: 'Son 24 saatteki para çekimleri',
    playerActivities: 'Oyuncu İşlemleri',
    lastLoginInfo: 'Son Giriş Bilgileri',
    registrationInfo: 'Kayıt Bilgisi',
    blockedProviders: 'Engellenen Sağlayıcılar',
    selectedProviders: 'Seçilmiş Sağlayıcılar',
    countryOfCitizenship: 'Vatandaşı Olunan Ülke',
    lCountryOfCitizenship: 'vatandaşı olunan ülke',
    citizenshipVerified: 'Vatandaşlık Doğrulandı',
    blockProviders: 'Sağlayıcıları Engelle',
    blockedProvidersList: 'Engellenen Sağlayıcılar listesi',
    responsibleGamingLimits: 'Sorumlu Oyun Limitleri',
    p2pGgr: 'P2P GGR',
    pep: 'PEP',
    verticalCategoryNoReasonInfo: 'Lütfen bu kategori için nedenleri etkinleştirin veya kategoriden neden koşulunu düzenleyin',
    clickToSeePendingFiles: 'Bekleyen dosyaları görmek için simgeye tıklayın',
    repetitionPeriod: 'Tekrarlama Periyodu',
    subAffiliateId: 'Alt Affiliate ID',
    repetitionDate: 'Tekrarlama Tarihi',
    approvalDate: 'Onay Tarihi',
    debtWallet: 'Borç Cüzdanı',
    personalNumericCode: 'Kişisel Sayısal Kod',
    personalNumericCodeNote: 'İşaretlenirse, Kişisel Sayısal Kod alanı Belge Doğrulama akışına eklenir, Belge ile doğrulanabilir ve farklı raporlarda görüntülenir.',
    brandRealityCheckLimitInfo: 'Limit tüm marka oyuncular için yapılandırılmıştır ve her bir oyuncu için limiti tek tek değiştirmek mümkün değildir',
    externalPlayerId: 'Harici Oyuncu ID',
    documentDescriptionInfo: 'Lütfen belgenin anlamını açıklayınız',
    realWalletBefore: 'Gerçek Cüzdan Önce',
    resetPassword: 'Şifreyi Sıfırla',
    PlayerMobileNumberInUse: 'Bu telefon numarasına sahip oyuncu zaten mevcut',
    PlayerEmailInUse: 'Bu e-posta adresine sahip oyuncu zaten mevcut',
    cpfNumber: 'CPF Numarası',
    disableTFA: "2FA'yı devre dışı bırak",
    tFA: '2FA',
    missingFieldsInAttachmentsInfo: 'Bu belgenin onaylanması için gerekli veriler doldurulmamıştır',
    year1LimitAmount: '1 Yıllık Limit Tutarı',
    pushNotification: 'Anlık Bildirim',
    indicators: 'Göstergeler',
    turnover: 'Ciro',
    totalNetBalance: 'Toplam Net Bakiye',
    extraWallets: 'Ekstra Cüzdanlar',
    tillDate: 'Tarihe kadar',
    tillDateInfo: 'Tarih, bugünden en az yedi gün sonra seçilebilir',
    currentType: 'Güncel Tür',
    upcomingType: 'Gelecek Tür',
    upcomingDate: 'Yaklaşan Tarih',
    editAccessLimit: 'Erişim Limitini Düzenle',
    weekDays: 'Hafta içi',
    inactivePeriodTime: 'Etkin Olmayan Dönem Süresi',
    setBy: 'Ayarla',
    effectDate: 'Başlangıç Tarihi',
    accessLimitTimezoneInfo: 'Erişim Limiti, marka varsayılan saat dilimiyle çalışır: {{timezone}}',
    upcoming: 'Yaklaşan',
    viewAccessLimit: 'Erişim Limitini Görüntüle',
    cpfNumberVerified: 'CPF Doğrulandı',
    deposit: 'Para Yatırma',
    withdrawal: 'Para Çekme',
    smsPreferencesDescription: 'Oyuncunun SMS bildirimi alacağı etkinlikleri seçin.',
    emailPreferencesDescription: 'Oyuncunun E-posta bildirimi alacağı etkinlikleri seçin.',
    pushPreferencesDescription: 'Oyuncunun Anlık Bildirimler alacağı etkinlikleri seçin.',
    blockedPayments: 'Engellenen Ödemeler',
    blockPayments: 'Ödemeleri Engelle',
    unblockPayments: 'Ödemeleri Engellemeyi Kaldır',
    endSessions: 'Oturumları Sonlandır',
    showLastLoginInfo: 'Son Oturum Açma Bilgilerini Göster',
    showLastLoginInfoNote: 'Bu özelliği etkinleştirerek, oyuncu web sitesinde son oturum açma bilgilerini görebilir.',
    day1HoursTimeLimit: '24 Saatlik Zaman Limiti',
    days7TimeLimit: '7 Günlük Zaman Limiti',
    month1TimeLimit: '1 Aylık Zaman Limiti',
    year1TimeLimit: '1 Yıllık Zaman Limiti',
    noExpiry: 'Süresi Yok',
    documentNoExpiryDateInfo: 'Bu seçeneği etkinleştirdiğinizde, belgenin geçerlilik süresi olmaz.',
    taxSessionID: 'Vergi Oturumu ID',
    taxSessionStart: 'Vergi Oturumu Başlangıcı',
    taxSessionEnd: 'Vergi Oturumu Bitişi',
    blockedDepositUntil: '{{date}} tarihine kadar bloke edilmiş para yatırma',
    blockedWithdrawalUntil: '{{date}} tarihine kadar bloke edilmiş para çekme ',
    paymentVerified: 'Ödeme Doğrulandı',
    fullVerified: 'Tamamen Doğrulanmış',
    allowedAttachmentsCountInfo: 'Seçilen belge türü için {{count}} ek dosyası yüklenmelidir.',
    dailyLimitAmount: 'Günlük Limit Tutarı',
    weeklyLimitAmount: 'Haftalık Limit Tutarı',
    monthlyLimitAmount: 'Aylık Limit Tutarı',
    annualLimitAmount: 'Yıllık Limit Tutarı',
    eddVerified: 'Edd Doğrulandı',
    enhancedDueDiligence: 'Gelişmiş Durum Tespiti',
  },
  ru: {
    identityVerified: 'Личность проверена',
    emailVerified: 'Адрес электронной почты проверен',
    mobileVerified: 'Номер мобильного телефона проверен',
    addressVerified: 'Адрес проверен',
    accountLocked: 'Учетная запись заблокирована',
    locked: 'Заблокировано',
    accountInactive: 'Учетная запись неактивна',
    blockedForMessages: 'Заблокировано для сообщений',
    closed: 'Закрыто',
    inactiveAccount: 'Неактивная учетная запись',
    accountInTimeout: 'Время ожидания учетной записи истекло',
    accountSelfExcluded: 'Самоисключение учетной записи',
    exclusionState: 'Состояние исключения',
    physicalVerification: 'Физическая верификация',
    blacklisted: 'Добавлено в список запрещенных',
    regDate: 'Дата регистрации',
    regIP: 'IP рег.',
    emailNotifications: 'Уведомления по электронной почте',
    SMSNotifications: 'SMS-уведомления',
    accountType: 'Тип учетной записи',
    accountUsers: 'Пользователи учетной записи',
    lastProvisionDate: 'Дата последнего обеспечения',
    lastAdjustmentDate: 'Дата последней корректировки',
    currencyDeletedOrDisabledTooltip: 'Валюта учетной записи, возможно, была деактивирована/удалена',
    adjustBalance: 'Корректировать баланс',
    finishUse: 'Завершить использование',
    closedAccountNote: 'Учетная запись будет закрыта и станет недоступной.',
    freeAccountNote: 'Учетная запись станет бесплатной для использования.',
    testAccountDetails: 'Детали тестовой учетной записи',
    userDetails: 'Детали пользователя',
    accountUser: 'Пользователь учетной записи',
    userEmail: 'Адрес электронной почты пользователя',
    userEmailTooltip: 'Логин и пароль учетной записи будут отправлены на указанный адрес электронной почты',
    adjust: 'Корректировать',
    moneyTransferred: 'Средства переведены',
    moneyUsed: 'Средства использованы',
    provisionDate: 'Дата обеспечения',
    providedBy: 'Предоставлено (кем)',
    attachmentId: 'ID приложения',
    startProcess: 'Начать процесс',
    manageFiles: 'Управлять файлами',
    blockControl: 'Блокировать контроль',
    unblockMessages: 'Разблокировать сообщения',
    investigationResults: 'Результаты расследования',
    noAvailableAccountInfo: 'Учетная запись больше не будет доступной для использования.',
    lComplete: 'завершено',
    lIncomplete: 'не завершено',
    accountVerificationProgress: 'Прогресс верификации учетной записи',
    newslettersAndPromotions: 'Рассылки и промоакции',
    betLimit: {
      modalTitle: 'Установить лимит ставок',
      name: 'Лимит ставок',
      description: 'Контролировать средства, расходуемые игроком на азартные игры',
      buttonText: 'Установить лимит',
    },
    withdrawalLimit: {
      modalTitle: 'Установить лимит для вывода средств',
      name: 'Лимит для вывода средств',
      description: 'Контролировать средства, выводимые игроком',
      buttonText: 'Установить лимит',
    },
    depositLimit: {
      modalTitle: 'Установить лимит депозитов',
      name: 'Лимит депозитов',
      description: 'Контролировать средства, зачисляемые игроком на счет для гемблинга',
      buttonText: 'Установить лимит',
    },
    timeOutLimit: {
      modalTitle: 'Установить время ожидания',
      name: 'Время ожидания',
      description: 'Дать игроку короткую паузу от всех игровых действий',
      buttonText: 'Установить время ожидания',
    },
    selfExclusionLimit: {
      modalTitle: 'Установить исключение',
      name: 'Самоисключение',
      description: 'Исключить игрока из всех игровых действий для сохранения контроля',
      buttonText: 'Установить исключение',
    },
    realityCheckLimit: {
      modalTitle: 'Установить проверку',
      name: 'Проверка реальности',
      description: 'Напомните игроку, сколько времени он провел на платформе',
      buttonText: 'Установить проверку',
    },
    accessLimit: {
      modalTitle: 'Установить ограничение доступа',
      name: 'Ограничение доступа',
      description: 'Ограничить доступ игрока к сайту',
      buttonText: 'Установить ограничение',
    },
    lossLimit: {
      modalTitle: 'Установите ограничение потерь',
      name: 'Ограничение потерь',
      description: 'Контролирует деньги, которые игрок теряет во время гемблинга',
      buttonText: 'Установить ограничение',
    },
    singleBetLimit: {
      modalTitle: 'Установите ограничение на одинар',
      name: 'Одинар',
      description: 'Контролирует максимальную сумму одинара, который может разместить игрок.',
      buttonText: 'Установить ограничение',
    },
    gameTimeLimit: {
      modalTitle: 'Установить ограничение по времени игры',
      name: 'Ограничение по времени игры',
      description: 'Контролирует время, потраченное на RNG-игры.',
      buttonText: 'Установить ограничение',
    },
    noLimit: 'Без ограничения',
    current: 'Текущий',
    remainder: 'Остаток',
    upcomingChanges: 'Предстоящие изменения',
    limitType: 'Тип ограничения',
    endOfLimitation: 'Завершение ограничения',
    appliedBy: 'Применено к',
    exportNoteInfo: 'Будут экспортированы данные за период до 6 месяцев.',
    accountStatusBeforeClosure: 'Статус учетной записи перед закрытием',
    accountRegistrationDate: 'Дата регистрации учетной записи',
    accountClosureDate: 'Дата закрытия учетной записи',
    reasonOfClosure: 'Причина закрытия',
    matchingCriteria: 'Критерии подбора',
    dateAgreed: 'Дата согласования',
    test: 'Тест',
    personalInformation: 'Личные данные',
    walletInformation: 'Информация о кошельке',
    countryCity: 'Страна, город',
    mobile: 'Мобильный телефон',
    documents: 'Документы',
    pendingFileGroups: 'Группы файлов, ожидающих обработки',
    verifiedWith: 'Проверено с',
    uploadAsApproved: 'Загрузить как одобренное',
    archive: 'Архив',
    unverifyPlayerIdentity: 'Отменить результаты проверки личности игрока',
    unverifyPlayerAddress: 'Отменить результаты проверки адреса игрока',
    fileNameAndExtension: 'Имя и расширение файла',
    approvedBy: 'Одобрено',
    notBlacklisted: 'Не в списке запрещенных',
    statusBefore: 'Статус до',
    statusAfter: 'Статус после',
    currentStatus: 'Текущий статус',
    playersWithMissingInfo: 'Игроки с недостающей информацией',
    verifyDocumentInfo: 'Перед верификацией убедитесь, что все одобренные документы содержат полную информацию.',
    notes: 'Примечания',
    markAttention: 'Пометка «Внимание»',
    playerSession: 'Сессия игрока',
    playerBalance: 'Баланс игрока',
    playersBalance: 'Балансы игроков',
    testPlayersAccount: 'Тестовая учетная запись игрока',
    accountUsersInformation: 'Информация об учетной записи игрока',
    process: 'Процесс',
    attentionLevel: 'Уровень внимания',
    playerNotes: 'Заметки игрока',
    cards: 'Карты',
    sessionId: 'ID сессии',
    sessionStart: 'Начало сессии',
    sessionEnd: 'Завершение сессии',
    sessionEndReason: 'Причина завершения сессии',
    walletTransactionId: 'ID транзакции кошелька',
    realWalletAfter: 'Реальный кошелек после',
    sumRealWallets: 'Сумма реальных кошельков',
    actionLogs: 'Журналы действий',
    day1HoursLimitAmount: '‎24-часовой лимит',
    days7LimitAmount: '‎7-дневный лимит',
    month1LimitAmount: 'Месячный лимит',
    lastDeposit: 'Последний депозит',
    takenMonthData: 'Учитываются только данные за последние {{count}} месяцев',
    method: 'Метод',
    lastWithdrawal: 'Последняя выплата',
    last24hDeposits: 'Депозиты в течение последних 24 часов',
    last24hWithdrawals: 'Выплаты в течение последних 24 часов',
    playerActivities: 'Действия игрока',
    lastLoginInfo: 'Информация о последнем входе',
    registrationInfo: 'Информация о регистрации',
    blockedProviders: 'Заблокированные провайдеры',
    selectedProviders: 'Выбранные провайдеры',
    countryOfCitizenship: 'Гражданство',
    lCountryOfCitizenship: 'гражданство',
    citizenshipVerified: 'гражданство подтверждено',
    blockProviders: 'Заблокировать провайдеров',
    blockedProvidersList: 'Список заблокрованных провайдеров',
    responsibleGamingLimits: 'Лимиты ответственной игры',
    p2pGgr: 'P2P GGR',
    pep: 'PEP',
    verticalCategoryNoReasonInfo: 'Пожалуйста, активируйте причины для этой категории или отредактируйте требования к причинам из категории',
    clickToSeePendingFiles: 'Нажмите на значок, чтобы увидеть файлы, ожидающие обработки',
    repetitionPeriod: 'Период повторения',
    subAffiliateId: 'ID субпартнера',
    repetitionDate: 'Дата повторения',
    approvalDate: 'Дата утверждения',
    debtWallet: 'Долговой кошелек',
    personalNumericCode: 'Персональный цифровой код',
    personalNumericCodeNote:
      'Если флажок установлен, поле Персональный цифровой код добавляется в поток Верификации документа и может быть верифицировано с Документом, а также доступно в различных отчетах.',
    brandRealityCheckLimitInfo: 'Лимит настраивается для всех игроков бренда, и изменить лимит для каждого игрока по отдельности невозможно',
    externalPlayerId: 'ID внешнего игрока',
    documentDescriptionInfo: 'Пожалуйста, опишите значение этого документа',
    realWalletBefore: 'Реальный кошелек до',
    resetPassword: 'Сбросить пароль',
    PlayerMobileNumberInUse: 'Игрок с таким номером телефона уже существует',
    PlayerEmailInUse: 'Игрок с таким адресом электронной почты уже существует',
    cpfNumber: 'Номер CPF',
    disableTFA: 'Отключить 2FA',
    tFA: '2FA',
    missingFieldsInAttachmentsInfo: 'Данные, необходимые для утверждения этого документа, не заполнены',
    year1LimitAmount: 'Сумма лимита на 1 год',
    pushNotification: 'Push-уведомление',
    indicators: 'Индикаторы',
    turnover: 'Оборот',
    totalNetBalance: 'Итого чистый баланс',
    extraWallets: 'Дополнительные кошельки',
    tillDate: 'До даты',
    tillDateInfo: 'До даты можно выбрать не менее чем через семь дней после текущей даты',
    currentType: 'Текущий тип',
    upcomingType: 'Предстоящий тип',
    upcomingDate: 'Предстоящая дата',
    editAccessLimit: 'Редактировать ограничение доступа',
    weekDays: 'Будни',
    inactivePeriodTime: 'Время бездействия',
    setBy: 'Установлено',
    effectDate: 'Дата вступления в силу',
    accessLimitTimezoneInfo: 'Ограничение доступа будет работать с часовым поясом бренда по умолчанию: {{timezone}}',
    upcoming: 'Предстоящий',
    viewAccessLimit: 'Просмотр ограничения доступа',
    cpfNumberVerified: 'CPF-проверено',
    deposit: 'Депозит',
    withdrawal: 'Вывод средств',
    smsPreferencesDescription: 'Выбрать события, о которых игрок будет получать SMS-уведомления.',
    emailPreferencesDescription: 'Выбрать события, о которых игрок будет получать уведомления по электронной почте.',
    pushPreferencesDescription: 'Выбрать события, о которых игрок будет получать push-уведомления.',
    blockedPayments: 'Заблокированные платежи',
    blockPayments: 'Блокировка платежей',
    unblockPayments: 'Разблокировка платежей',
    endSessions: 'Окончание сессий',
    showLastLoginInfo: 'Показать информацию о последнем входе в систему',
    showLastLoginInfoNote: 'При включении этой функции игрок будет видеть последние данные для входа на сайт.',
    day1HoursTimeLimit: 'Ограничение по времени 24 часа',
    days7TimeLimit: 'Ограничение по времени 7 дней',
    month1TimeLimit: 'Ограничение по времени 1 месяц',
    year1TimeLimit: 'Ограничение по времени 1 год',
    noExpiry: 'Без срока действия',
    documentNoExpiryDateInfo: 'Если включить эту функцию, документ не будет иметь срока действия.',
    taxSessionID: 'ID налоговой сессии',
    taxSessionStart: 'Начало налоговой сессии',
    taxSessionEnd: 'Окончание налоговой сессии',
    blockedDepositUntil: 'Заблокированный депозит до {{date}}',
    blockedWithdrawalUntil: 'Заблокированный вывод средств до {{date}}',
    paymentVerified: 'Оплата верифицирована',
    fullVerified: 'Полностью верифицировано',
    allowedAttachmentsCountInfo: 'Для выбранного типа документа необходимо загрузить {{count}} вложений.',
    dailyLimitAmount: 'Ежедневная предельная сумма',
    weeklyLimitAmount: 'Еженедельная предельная сумма',
    monthlyLimitAmount: 'Ежемесячная предельная сумма',
    annualLimitAmount: 'Ежегодная предельная сумма',
    eddVerified: 'EDD-верифицировано',
    enhancedDueDiligence: 'Усиленная комплексная проверка',
    setOTP: 'Установить OTP',
    setPlayerOTPInfo: 'OTP остаётся видимым, пока игрок не изменит свой пароль, после чего он автоматически удаляется. Вы можете сгенерировать новый OTP в любое время при необходимости.',
    oneTimePassword: 'Одноразовый пароль',
    legacyData: 'Устаревшие данные',
    dailyLimit: 'Суточный лимит',
    day1HoursLimit: 'Лимит (24 часа)',
    weeklyLimit: 'Недельный лимит',
    days7Limit: 'Лимит (7 дней)',
    monthlyLimit: 'Месячный лимит',
    month1Limit: 'Лимит (1 месяц)',
    annualLimit: 'Годовой лимит',
    year1Limit: 'Лимит (1 год)',
    dateOfBirthDate: 'Дата рождения: Дата',
    dateOfBirthMonth: 'Дата рождения: Месяц',
    personal: 'Личные данные',
    wallet: 'Кошелек',
    docs: 'Документы',
    changeLayout: 'Изменить лейаут',
    top: 'Вверху',
    left: 'Слева',
    right: 'Справа',
    accumulatedTax: 'Накопленный налог',
    numberOfLevel: 'Уровень {{number}}',
    sportOpenBets: 'Открытые ставки (спорт)',
    unblockPayment: 'Разблокировать платежи',
    otp: 'OTP',
    generate: 'Сгенерировать',
    regenerate: 'Снова сгенерировать',
    addNewNote: 'Добавить новую заметку',
    lastTrigger24HoursLimitAmount: 'Последний триггер Лимит суммы за последние 24 часа',
    lastTrigger7DaysLimitAmount: 'Последний триггер Лимит суммы за последние 7 дней',
    lastTrigger1MonthLimitAmount: 'Последний триггер Лимит суммы за последний 1 месяц',
    lastTrigger1YearLimitAmount: 'Последний триггер Лимит суммы за последний 1 год',
    paydromAccount: 'Аккаунт Paydrom',
    episServersDownInfo: 'Серверы EPIS не отвечают',
    placeOfIssue: 'Место выдачи',
    choosePlaceOfIssue: 'Выбрать место выдачи',
    months: 'Месяцы',
    episVerified: 'EPIS верифицирован',
    episNotVerified: 'EPIS не верифицирован',
    rutNumber: 'Номер RUT',
  },
  pt: {
    identityVerified: 'Identidade Verificada',
    emailVerified: 'E-mail Verificado',
    mobileVerified: 'Telemóvel Verificado',
    addressVerified: 'Endereço Verificado',
    accountLocked: 'Conta Bloqueada',
    locked: 'Bloqueada',
    accountInactive: 'Conta Inativa',
    blockedForMessages: 'Bloqueado para Mensagens',
    closed: 'Fechada',
    inactiveAccount: 'Conta Inativa',
    accountInTimeout: 'Conta em Time-out',
    accountSelfExcluded: 'Conta autoexcluída',
    exclusionState: 'Estado da Exclusão',
    physicalVerification: 'Verificação Física',
    blacklisted: 'Colocado na Lista de Proibidos',
    regDate: 'Data de Reg.',
    regIP: 'IP de Reg.',
    emailNotifications: 'Notificações por E-mail',
    SMSNotifications: 'Notificações SMS',
    accountType: 'Tipo de Conta',
    accountUsers: 'Utilizadores da Conta',
    lastProvisionDate: 'Data da Última Disposição',
    lastAdjustmentDate: 'Data do Último Ajuste',
    currencyDeletedOrDisabledTooltip: 'A moeda da conta pode ter sido desativada/apagada',
    adjustBalance: 'Ajustar o Saldo',
    finishUse: 'Utilização Final',
    closedAccountNote: 'A conta será fechada e já não estará disponível.',
    freeAccountNote: 'A conta será gratuita para utilização.',
    testAccountDetails: 'Dados da Conta de Teste',
    userDetails: 'Dados do Utilizador',
    accountUser: 'Conta de Utilizador',
    userEmail: 'E-mail do Utilizador',
    userEmailTooltip: 'As credenciais da conta serão enviadas para o e-mail fornecido',
    adjust: 'Ajuste',
    moneyTransferred: 'Dinheiro Transferido',
    moneyUsed: 'Dinheiro Utilizado',
    provisionDate: 'Data da Provisão',
    providedBy: 'Fornecido por',
    attachmentId: 'ID do Anexo',
    startProcess: 'Iniciar Processo',
    manageFiles: 'Gerir Arquivos',
    blockControl: 'Controlo de Bloco',
    unblockMessages: 'Desbloquear Mensagens',
    investigationResults: 'Resultados da Investigação',
    noAvailableAccountInfo: 'A conta já não estará disponível para utilização.',
    lComplete: 'completo',
    lIncomplete: 'incompleto',
    accountVerificationProgress: 'Progresso da Verificação de Conta',
    newslettersAndPromotions: 'Newsletters e Promoções',
    betLimit: {
      modalTitle: 'Definir Limite de Aposta',
      name: 'Limite de Aposta',
      description: 'Controlar o dinheiro que o jogador gasta em apostas',
      buttonText: 'Definir Limite',
    },
    withdrawalLimit: {
      modalTitle: 'Definir Limite de Levantamento',
      name: 'Limite de Levantamento',
      description: 'Controlar o dinheiro levantado pelo jogador',
      buttonText: 'Definir Limite',
    },
    depositLimit: {
      modalTitle: 'Definir Limite de Depósito',
      name: 'Limite de Depósito',
      description: 'Controlar o dinheiro depositado pelo jogador para apostas',
      buttonText: 'Definir Limite',
    },
    timeOutLimit: {
      modalTitle: 'Definir Time-out',
      name: 'Time-out',
      description: 'Oferecer ao jogador um intervalo de todas as atividades de jogo',
      buttonText: 'Definir Time-out',
    },
    selfExclusionLimit: {
      modalTitle: 'Definir Exclusão',
      name: 'Autoexclusão',
      description: 'Excluir o jogador de todas as atividades de jogo para este manter o controlo',
      buttonText: 'Definir Exclusão',
    },
    realityCheckLimit: {
      modalTitle: 'Definir verificação',
      name: 'Verificação da realidade',
      description: 'Lembrar o valor gasto pelo jogador na plataforma',
      buttonText: 'Definir verificação',
    },
    accessLimit: {
      modalTitle: 'Definir limite de acesso',
      name: 'Limite de acesso',
      description: 'Limitar o acesso do jogador ao site',
      buttonText: 'Definir limite',
    },
    lossLimit: {
      modalTitle: 'Definir limite de perda',
      name: 'Limite de perda',
      description: 'Controla o dinheiro que o jogador perde durante o jogo',
      buttonText: 'Definir limite',
    },
    singleBetLimit: {
      modalTitle: 'Definir limite para aposta única',
      name: 'Aposta única',
      description: 'Controla o valor máximo de aposta única que o jogador pode apostar',
      buttonText: 'Definir limite',
    },
    gameTimeLimit: {
      modalTitle: 'Definir limite de tempo do jogo',
      name: 'Limite de tempo do jogo',
      description: 'Controla o tempo gasto em jogos RNG.',
      buttonText: 'Definir limite',
    },
    noLimit: 'Sem Limite',
    current: 'Atual',
    remainder: 'Lembrete',
    upcomingChanges: 'Próximas Alterações',
    limitType: 'Tipo de Limite',
    endOfLimitation: 'Fim do Limite',
    appliedBy: 'Aplicado por',
    exportNoteInfo: 'Serão exportados dados de até 6 meses.',
    accountStatusBeforeClosure: 'Estado da Conta Antes do Encerramento',
    accountRegistrationDate: 'Data de Registo da Conta',
    accountClosureDate: 'Data de Encerramento da Conta',
    reasonOfClosure: 'Motivo do Encerramento',
    matchingCriteria: 'Critérios de Correspondência',
    dateAgreed: 'Data Acordada',
    test: 'Teste',
    personalInformation: 'Informações Pessoais',
    walletInformation: 'Informações da Carteira',
    countryCity: 'País, Cidade',
    mobile: 'Celular',
    documents: 'Documentos',
    pendingFileGroups: 'Grupos de Arquivos Pendentes',
    verifiedWith: 'Verificado com',
    uploadAsApproved: 'Carregar Conforme Aprovado',
    archive: 'Arquivar',
    unverifyPlayerIdentity: 'Não verificar a identidade do jogador',
    unverifyPlayerAddress: 'Não verificar o endereço do jogador',
    fileNameAndExtension: 'Nome do arquivo e extensão',
    approvedBy: 'Aprovado por',
    notBlacklisted: 'Não está na Lista de Proibidos',
    statusBefore: 'Estado Antes',
    statusAfter: 'Estado Após',
    currentStatus: 'Estado Atual',
    playersWithMissingInfo: 'Jogadores com informações em falta',
    verifyDocumentInfo: 'Certifique-se de que todos os documentos aprovados contenham informações completas antes da verificação.',
    notes: 'Notas',
    markAttention: 'Marcar Atenção',
    playerSession: 'Sessão do jogador',
    playerBalance: 'Saldo do jogador',
    playersBalance: 'Saldos dos Jogadores',
    testPlayersAccount: 'Conta do jogador de teste',
    accountUsersInformation: 'Informações do utilizador da conta',
    process: 'Processo',
    attentionLevel: 'Nível de Atenção',
    playerNotes: 'Notas do Jogador',
    cards: 'Cartas',
    sessionId: 'ID da Sessão',
    sessionStart: 'Início da Sessão',
    sessionEnd: 'Fim da Sessão',
    sessionEndReason: 'Motivo do Fim da Sessão',
    walletTransactionId: 'ID da Carteira TXN',
    realWalletAfter: 'Carteira Real Após',
    sumRealWallets: 'Soma das Carteiras Reais',
    actionLogs: 'Registos de Ações',
    day1HoursLimitAmount: 'Valor de Limite de 24 Horas',
    days7LimitAmount: 'Valor de Limite de 7 Dias',
    month1LimitAmount: 'Valor de Limite de 1 Mês',
    lastDeposit: 'Último Depósito',
    takenMonthData: 'Apenas são levados em consideração os dados dos últimos {{count}} meses',
    method: 'Método',
    lastWithdrawal: 'Último Levantamento',
    last24hDeposits: 'Depósitos nas últimas 24h',
    last24hWithdrawals: 'Levantamentos nas últimas 24h',
    playerActivities: 'Atividades do Jogador',
    lastLoginInfo: 'Informações Sobre o Último Login',
    registrationInfo: 'Informações de Registo',
    blockedProviders: 'Fornecedores Bloqueados',
    selectedProviders: 'Fornecedores Selecionados',
    countryOfCitizenship: 'País de Cidadania',
    lCountryOfCitizenship: 'país de cidadania',
    citizenshipVerified: 'Cidadania Verificada',
    blockProviders: 'Bloquear Fornecedores',
    blockedProvidersList: 'Lista de Fornecedores Bloqueados',
    responsibleGamingLimits: 'Limites do Jogo Responsável',
    p2pGgr: 'P2P GGR',
    pep: 'PEP',
    verticalCategoryNoReasonInfo: 'Por favor, ative os motivos para esta categoria ou edite o requisito relativo aos motivos a partir da categoria',
    clickToSeePendingFiles: 'Clique no ícone para ver os arquivos pendentes',
    repetitionPeriod: 'Período de Repetição',
    subAffiliateId: 'ID do Subafiliado',
    repetitionDate: 'Data de Repetição',
    approvalDate: 'Data de aprovação',
    debtWallet: 'Carteira de Dívidas',
    personalNumericCode: 'Código numérico pessoal',
    personalNumericCodeNote:
      'Se estiver selecionado, o campo Código numérico pessoal é adicionado ao fluxo de verificação de documentos, pode ser verificado com o documento e está disponível em diferentes relatórios.',
    brandRealityCheckLimitInfo: 'O limite é configurado para todos os jogadores da marca, e não é possível alterar o limite para o jogador individualmente',
    externalPlayerId: 'ID do jogador externo',
    documentDescriptionInfo: 'Por favor, descreva o significado do documento',
    realWalletBefore: 'Carteira Real Antes',
    resetPassword: 'Redefinir palavra-passe',
    PlayerMobileNumberInUse: 'Já existe um jogador com este número de telefone',
    PlayerEmailInUse: 'Já existe um jogador com este endereço de correio eletrónico',
    cpfNumber: 'Número do CPF',
    disableTFA: 'Desativar 2FA',
    tFA: '2FA',
    missingFieldsInAttachmentsInfo: 'Os dados necessários para a aprovação deste documento não foram preenchidos',
    year1LimitAmount: 'Valor Limite de 1 ano ',
    pushNotification: 'Notificação Push ',
    indicators: 'Indicadores',
    turnover: 'Turnover',
    totalNetBalance: 'Saldo líquido total',
    extraWallets: 'Carteiras extra',
    tillDate: 'Data até',
    tillDateInfo: 'A data até pode ser selecionada pelo menos sete dias após a data atual',
    currentType: 'Tipo atual',
    upcomingType: 'Tipo futuro',
    upcomingDate: 'Próxima data',
    editAccessLimit: 'Editar limite de acesso',
    weekDays: 'Dias da semana',
    inactivePeriodTime: 'Tempo do período inativo',
    setBy: 'Definido por',
    effectDate: 'Data de efeito',
    accessLimitTimezoneInfo: 'O Limite de Acesso funcionará com o fuso horário predefinido da marca: {{timezone}}',
    upcoming: 'Próximo',
    viewAccessLimit: 'Ver limite de acesso',
    cpfNumberVerified: 'CPF verificado',
    deposit: 'Depósito',
    withdrawal: 'Retirada',
    smsPreferencesDescription: 'Selecione os eventos para os quais o jogador irá receber notificações por SMS.',
    emailPreferencesDescription: 'Selecione os eventos para os quais o jogador irá receber notificações por e-mail.',
    pushPreferencesDescription: 'Selecione os eventos para os quais o jogador irá receber notificações Push.',
    blockedPayments: 'Pagamentos bloqueados',
    blockPayments: 'Bloquear pagamentos',
    unblockPayments: 'Desbloquear pagamentos',
    endSessions: 'Fim das sessões',
    showLastLoginInfo: 'Mostrar últimas informações de login',
    showLastLoginInfoNote: 'Ao habilitar o jogador verá as últimas informações de login no site.',
    day1HoursTimeLimit: 'Limite de tempo de 24 horas',
    days7TimeLimit: 'Limite de tempo de 7 dias',
    month1TimeLimit: 'Limite de tempo de 1 mês',
    year1TimeLimit: 'Limite de tempo de 1 ano',
    noExpiry: 'Sem expiração',
    documentNoExpiryDateInfo: 'Ao habilitar isso, o documento não terá data de validade.',
    taxSessionID: 'ID da sessão fiscal',
    taxSessionStart: 'Início da sessão fiscal',
    taxSessionEnd: 'Fim da sessão fiscal',
    blockedDepositUntil: 'Depósito bloqueado até {{date}}',
    blockedWithdrawalUntil: 'Retirada bloqueada até {{date}}',
    paymentVerified: 'Pagamento verificado',
    fullVerified: 'Totalmente verificado',
    allowedAttachmentsCountInfo: 'Para o tipo de documento selecionado, devem ser enviados {{count}} anexos',
    dailyLimitAmount: 'Valor do Limite Diário',
    weeklyLimitAmount: 'Valor do Limite Semanal',
    monthlyLimitAmount: 'Valor do Limite Mensal',
    annualLimitAmount: 'Valor do Limite Anual',
    eddVerified: 'Edd Verificado',
    enhancedDueDiligence: 'Due Diligence Aprimorada',
    setOTP: 'Definir OTP',
    setPlayerOTPInfo: 'O OTP permanece visível até que o jogador altere sua senha e, em seguida, é removido automaticamente. Você pode gerar um novo OTP a qualquer momento, se necessário.',
    oneTimePassword: 'Senha de uso único',
    legacyData: 'Dados legados',
    dailyLimit: 'Limite diário',
    day1HoursLimit: 'Limite de 24 anos',
    weeklyLimit: 'Limite semanal',
    days7Limit: 'Limite de 7 dias',
    monthlyLimit: 'Limite mensal',
    month1Limit: 'Limite de 1 mês',
    annualLimit: 'Limite atual',
    year1Limit: 'Limite de 1 ano',
    dateOfBirthDate: 'Data de nascimento: dia',
    dateOfBirthMonth: 'Data de nascimento: mês',
    personal: 'Pessoal',
    wallet: 'Carteira',
    docs: 'Documentos',
    changeLayout: 'Alterar layout',
    top: 'Superior',
    left: 'Esquerda',
    right: 'Direita',
    accumulatedTax: 'Imposto acumulado',
    numberOfLevel: 'Nível {{number}}',
    sportOpenBets: 'Apostas esportivas abertas',
    unblockPayment: 'Desbloquear pagamento',
    otp: 'OTP',
    generate: 'Gerar',
    regenerate: 'Regenerar',
    addNewNote: 'Adicionar nova nota',
    lastTrigger24HoursLimitAmount: 'Valor do limite do último acionamento nas últimas 24 horas',
    lastTrigger7DaysLimitAmount: 'Valor do limite do último acionamento nos últimos 7 dias',
    lastTrigger1MonthLimitAmount: 'Valor do limite do último acionamento no último mês',
    lastTrigger1YearLimitAmount: 'Valor do limite do último acionamento no último ano',
    paydromAccount: 'Conta Paydrom',
    episServersDownInfo: 'Servidores EPIS não estão respondendo',
    placeOfIssue: 'Local de emissão',
    choosePlaceOfIssue: 'Selecionar local de emissão',
    months: 'Meses',
    episVerified: 'EPIS verificado',
    episNotVerified: 'EPIS não verificado',
    rutNumber: 'Número RUT',
  },
  zh: {
    identityVerified: '身份已验证',
    emailVerified: '已验证电子邮箱',
    mobileVerified: '已验证手机',
    addressVerified: '地址已验证',
    accountLocked: '账户已锁定',
    locked: '已锁定',
    accountInactive: '账户未激活',
    blockedForMessages: '屏蔽信息',
    closed: '已关闭',
    inactiveAccount: '未激活账户',
    accountInTimeout: '账户处于暂停期',
    accountSelfExcluded: '账户处于自我禁制期',
    exclusionState: '排除状态',
    physicalVerification: '物理验证',
    blacklisted: '被列入黑名单',
    regDate: '注册日期',
    regIP: '注册IP',
    emailNotifications: '电子邮箱通知',
    SMSNotifications: '短信通知',
    accountType: '账户类型',
    accountUsers: '账户持有者',
    lastProvisionDate: '最近提供日期',
    lastAdjustmentDate: '最近调整日期',
    currencyDeletedOrDisabledTooltip: '账户货币可能已禁用/删除',
    adjustBalance: '调整余额',
    finishUse: '完成使用',
    closedAccountNote: '账户即将关闭，并将不再可用。',
    freeAccountNote: '账户将免费可用。',
    testAccountDetails: '测试账户详情',
    userDetails: '用户详情',
    accountUser: '账户持有者',
    userEmail: '用户电子邮箱',
    userEmailTooltip: '账户的凭证将被发送到所提供的电子邮箱中',
    adjust: '调整',
    moneyTransferred: '已转账',
    moneyUsed: '已使用资金',
    provisionDate: '提供日期',
    providedBy: '提供',
    attachmentId: '附件ID',
    startProcess: '开始进程',
    manageFiles: '管理文件',
    blockControl: '屏蔽控制',
    unblockMessages: '解除屏蔽信息',
    investigationResults: '调查结果',
    noAvailableAccountInfo: '账户即将不再可用。',
    lComplete: '完成',
    lIncomplete: '未完成',
    accountVerificationProgress: '账户验证流程',
    newslettersAndPromotions: '新闻简报和促销',
    betLimit: {
      modalTitle: '设置投注限制',
      name: '投注限制',
      description: '控制玩家在赌博上消费的资金',
      buttonText: '设置限制',
    },
    withdrawalLimit: {
      modalTitle: '设置取款限制',
      name: '取款限制',
      description: '控制玩家提取的资金',
      buttonText: '设置限制',
    },
    depositLimit: {
      modalTitle: '设置存款限制',
      name: '存款限制',
      description: '控制玩家为赌博而存入的资金',
      buttonText: '设置限制',
    },
    timeOutLimit: {
      modalTitle: '设置暂停时间',
      name: '暂停时间',
      description: '让玩家从所有的赌博活动中短暂休息',
      buttonText: '设置暂停时间',
    },
    selfExclusionLimit: {
      modalTitle: '设置排除条件',
      name: '自我禁制',
      description: '将玩家排除在所有赌博活动之外，以保持控制',
      buttonText: '设置排除项',
    },
    realityCheckLimit: {
      modalTitle: '设置检验',
      name: '真实性检验',
      description: '提醒玩家在平台上的消费',
      buttonText: '设置检验',
    },
    accessLimit: {
      modalTitle: '设置访问限制',
      name: '访问限制',
      description: '限制玩家访问网站',
      buttonText: '设置限制',
    },
    lossLimit: {
      modalTitle: '设定损失限额',
      name: '损失限额',
      description: '控制玩家在赌博时输掉的钱',
      buttonText: '设置限制',
    },
    singleBetLimit: {
      modalTitle: '设置单注设置',
      name: '单注设置',
      description: '控制玩家可以下注的最大单笔投注金额',
      buttonText: '设置限制',
    },
    gameTimeLimit: {
      modalTitle: '设置游戏时间限制',
      name: '游戏时间限制',
      description: '控制RNG游戏所花费的时间。',
      buttonText: '设置限制',
    },
    noLimit: '无限制',
    current: '当前',
    remainder: '剩余部分',
    upcomingChanges: '即将发生的变化',
    limitType: '限制类型',
    endOfLimitation: '限制结束',
    appliedBy: '应用',
    exportNoteInfo: '将导出最多6个月的数据。',
    accountStatusBeforeClosure: '关闭前的账户状态',
    accountRegistrationDate: '账户注册日期',
    accountClosureDate: '账户关闭日期',
    reasonOfClosure: '关闭原因',
    matchingCriteria: '匹配标准',
    dateAgreed: '商定日期',
    test: '测试',
    personalInformation: '个人信息',
    walletInformation: '钱包信息',
    countryCity: '国家/地区，城市',
    mobile: '手机',
    documents: '文件',
    pendingFileGroups: '待处理文件组',
    verifiedWith: '验证经由',
    uploadAsApproved: '经批准后上传',
    archive: '归档',
    unverifyPlayerIdentity: '解除验证玩家身份',
    unverifyPlayerAddress: '解除验证玩家地址',
    fileNameAndExtension: '文件名和扩展',
    approvedBy: '已通过',
    notBlacklisted: '未被列入黑名单',
    statusBefore: '之前状态',
    statusAfter: '之后状态',
    currentStatus: '当前状态',
    playersWithMissingInfo: '缺失信息的玩家',
    verifyDocumentInfo: '确保所有批准的文件在核查前都包含完整的信息。',
    notes: '备注',
    markAttention: '标记关注',
    playerSession: '玩家会话',
    playerBalance: '玩家余额',
    playersBalance: '玩家余额',
    testPlayersAccount: '测试玩家账户',
    accountUsersInformation: '账户持有者信息',
    process: '处理',
    attentionLevel: '注意等级',
    playerNotes: '玩家备注',
    cards: '卡',
    sessionId: '专场ID',
    sessionStart: '专场开始',
    sessionEnd: '专场结束',
    sessionEndReason: '专场结束原因',
    walletTransactionId: '钱包交易ID',
    realWalletAfter: '真实钱包之后',
    sumRealWallets: '合计真实钱包',
    actionLogs: '操作日志',
    day1HoursLimitAmount: '24小时限额金额',
    days7LimitAmount: '7天限制金额',
    month1LimitAmount: '1个月限制金额',
    lastDeposit: '最后一次存款',
    takenMonthData: '顾及只过去{{count}}个月的数据',
    method: '方式',
    lastWithdrawal: '最后一次取款',
    last24hDeposits: '最后24小时内的存款',
    last24hWithdrawals: '最后24小时内的取款',
    playerActivities: '玩家活动',
    lastLoginInfo: '上次登录信息',
    registrationInfo: '注册信息',
    blockedProviders: '被封禁的提供商',
    countryOfCitizenship: '国籍国',
    lCountryOfCitizenship: '国籍国',
    citizenshipVerified: '公民身份得到确认',
    blockProviders: '阻止提供程序',
    blockedProvidersList: '阻止的提供程序列表',
    pep: 'PEP',
    verticalCategoryNoReasonInfo: '请激活此类别的原因或编辑类别中的原因要求',
    selectedProviders: '选定的供应商',
    responsibleGamingLimits: '负责任的游戏限制',
    p2pGgr: 'P2P GGR',
    clickToSeePendingFiles: '请单击图标查看挂起的文件',
    repetitionPeriod: '复读期',
    subAffiliateId: '子伙伴ID',
    repetitionDate: '复读期',
    approvalDate: '批准日期',
    debtWallet: '债务钱包',
    personalNumericCode: '个人数字代码',
    personalNumericCodeNote: '如果选中，个人数字代码字段将添加到文档验证流程中，可与文档一起验证，并在不同的报告中提供。',
    brandRealityCheckLimitInfo: '该限制是为所有品牌玩家配置的，无法单独更改玩家的限制',
    externalPlayerId: '外部玩家ID',
    documentDescriptionInfo: '请说明该文件的含义',
    realWalletBefore: '真实钱包之前',
    resetPassword: '重置密码',
    PlayerMobileNumberInUse: '已存在使用此电话号码的玩家',
    PlayerEmailInUse: '已存在使用此电子邮件地址的玩家',
    cpfNumber: 'CPF号',
    disableTFA: '停用2FA',
    tFA: '2FA',
    missingFieldsInAttachmentsInfo: '批准本文件所需的数据尚未填写',
    year1LimitAmount: '1年限制金额',
    pushNotification: '推送通知',
    indicators: '指标',
    turnover: '周转',
    totalNetBalance: '净余额共计',
    extraWallets: '额外钱包',
    tillDate: '截至日期',
    tillDateInfo: '截止日期可选在当前日期之后至少七天',
    currentType: '当前类型',
    upcomingType: '即将推出的类型',
    upcomingDate: '即将到来的日期',
    editAccessLimit: '编辑访问限制',
    weekDays: '工作日',
    inactivePeriodTime: '非活跃期时间',
    setBy: '设置',
    effectDate: '生效日期',
    accessLimitTimezoneInfo: '访问限制将使用品牌默认时区：{{timezone}}',
    upcoming: '即将到来',
    viewAccessLimit: '查看访问限制',
    cpfNumberVerified: 'CPF已验证',
    deposit: '存款',
    withdrawal: '取款',
    smsPreferencesDescription: '选择玩家将收到短信通知的事件。',
    emailPreferencesDescription: '选择玩家将收到电子邮件通知的事件。',
    pushPreferencesDescription: '选择玩家将收到推送通知的事件。',
    blockedPayments: '被屏蔽付款',
    blockPayments: '屏蔽付款',
    unblockPayments: '解除屏蔽付款',
    endSessions: '结束会话',
    showLastLoginInfo: '显示上次登录信息',
    showLastLoginInfoNote: '通过启用，玩家将看到网站上的最后登录信息。',
    day1HoursTimeLimit: '24小时时限',
    days7TimeLimit: '7天时限',
    month1TimeLimit: '一个月时限',
    year1TimeLimit: '一年时限',
    noExpiry: '无到期',
    documentNoExpiryDateInfo: '启用此功能后，文档将不会有过期日期。',
    taxSessionID: '税务会话ID',
    taxSessionStart: '税务会话开始',
    taxSessionEnd: '税务会话结束',
    blockedDepositUntil: '冻结存款直至 {{date}}',
    blockedWithdrawalUntil: '提款冻结至 {{date}}',
    paymentVerified: '付款已验证',
    fullVerified: '完全验证',
    allowedAttachmentsCountInfo: '对于选定的文档类型，应上传 {{count}} 个附件',
    dailyLimitAmount: '每日限额',
    weeklyLimitAmount: '每周限额',
    monthlyLimitAmount: '每月限额',
    annualLimitAmount: '每年限额',
    eddVerified: 'EDD已验证',
    enhancedDueDiligence: '加强尽职调查',
    setPlayerOTPInfo: 'OTP 会保持可见，直到玩家更改密码后自动移除。如有需要，您可以随时生成新的 OTP。',
    oneTimePassword: '一次性密码',
    setOTP: '设置 OTP',
    legacyData: '旧数据',
    dailyLimit: '每日限额',
    day1HoursLimit: '24 小时限额',
    weeklyLimit: '每周限额',
    days7Limit: '7 天限额',
    monthlyLimit: '每月限额',
    month1Limit: '1 个月限额',
    annualLimit: '年度限额',
    year1Limit: '1 年限额',
    dateOfBirthDate: '出生日：日',
    dateOfBirthMonth: '出生日：月',
    personal: '个人',
    wallet: '钱包',
    docs: '文件',
    changeLayout: '更改布局',
    top: '顶部',
    left: '左侧',
    right: '右侧',
    accumulatedTax: '累计税额',
    numberOfLevel: '等级 {{number}}',
    sportOpenBets: '体育未结投注',
    unblockPayment: '解除支付封锁',
    otp: 'OTP',
    generate: '生成',
    regenerate: '重新生成',
    addNewNote: '添加新备注',
    lastTrigger24HoursLimitAmount: '最近 24 小时触发限额',
    lastTrigger7DaysLimitAmount: '最近 7 天触发限额',
    lastTrigger1MonthLimitAmount: '最近 1 个月触发限额',
    lastTrigger1YearLimitAmount: '最近 1 年触发限额',
    paydromAccount: 'Paydrom 账户',
    episServersDownInfo: 'EPIS 服务器无响应',
    placeOfIssue: '签发地点',
    choosePlaceOfIssue: '选择签发地点',
    months: '月',
    episVerified: 'EPIS 已验证',
    episNotVerified: 'EPIS 未验证',
    rutNumber: 'RUT 编号',
  },
  ro: {
    lastDeposit: 'Ultimul depozit',
    takenMonthData: 'Sunt luate în considerare numai datele din ultimele {{count}} luni',
    method: 'Metodă',
    lastWithdrawal: 'Ultima retragere',
    last24hDeposits: 'Depuneri în ultimele 24 de ore',
    last24hWithdrawals: 'Retrageri în ultimele 24 de ore',
    playerActivities: 'Acțiunile jucătorilor',
    lastLoginInfo: 'Ultimele informații de conectare',
    registrationInfo: 'Informații de înregistrare',
    blockedProviders: 'Furnizori blocați',
    identityVerified: 'Identitate verificată',
    emailVerified: 'E-mail verificat',
    mobileVerified: 'Telefon mobil verificat',
    addressVerified: 'Adresă verificată',
    accountLocked: 'Cont blocat',
    locked: 'Blocat',
    accountInactive: 'Cont inactiv',
    blockedForMessages: 'Blocat pentru mesaje',
    closed: 'Închis',
    inactiveAccount: 'Cont inactiv',
    accountInTimeout: 'Cont expirat',
    accountSelfExcluded: 'Cont auto-exclus',
    exclusionState: 'Stare de excludere',
    physicalVerification: 'Verificare fizică',
    blacklisted: 'Pe lista neagră',
    regDate: 'Data de înreg.',
    regIP: 'IP de înreg.',
    emailNotifications: 'Notificări prin e-mail',
    SMSNotifications: 'Notificări prin SMS',
    accountType: 'Tip de cont',
    accountUsers: 'Utilizatori de cont',
    lastProvisionDate: 'Data ultimei prevederi',
    lastAdjustmentDate: 'Data ultimei ajustări',
    currencyDeletedOrDisabledTooltip: 'Este posibil ca moneda contului să fie dezactivată/ștearsă',
    adjustBalance: 'Completează soldul',
    finishUse: 'Închide utilizarea',
    closedAccountNote: 'Contul va fi închis și nu va mai fi disponibil.',
    freeAccountNote: 'Contul va deveni gratuit pentru utilizare.',
    testAccountDetails: 'Detalii ale contului de testare',
    userDetails: 'Detalii de utilizator',
    accountUser: 'Utilizator de cont',
    userEmail: 'E-mail de utilizator',
    userEmailTooltip: 'Acreditările contului vor fi trimise la adresa de e-mail furnizată',
    adjust: 'Completează',
    moneyTransferred: 'Bani transferați',
    moneyUsed: 'Bani folosiți',
    provisionDate: 'Data de prevedere',
    providedBy: 'Furnizat de',
    attachmentId: 'ID de atașament',
    startProcess: 'Începe procesul',
    manageFiles: 'Gestiona fișierele',
    blockControl: 'Control de blocare',
    unblockMessages: 'Debloca mesaje',
    investigationResults: 'Rezultate de investigație',
    noAvailableAccountInfo: 'Contul nu va mai fi disponibil pentru utilizare.',
    lComplete: 'completat',
    lIncomplete: 'incomplet',
    accountVerificationProgress: 'Progres de verificare al contului',
    newslettersAndPromotions: 'Buletine informative și promoții',
    noLimit: 'Fără limită',
    current: 'Curent',
    remainder: 'Rest',
    upcomingChanges: 'Schimbări viitoare',
    limitType: 'Tip de limită',
    endOfLimitation: 'Sfârșit de limitări',
    appliedBy: 'Aplicat de',
    exportNoteInfo: 'Datele de până la 6 luni vor fi exportate.',
    accountStatusBeforeClosure: 'Starea contului înainte de închidere',
    accountRegistrationDate: 'Data înregistrării contului',
    accountClosureDate: 'Data închiderii contului',
    reasonOfClosure: 'Motivul închiderii',
    matchingCriteria: 'Criterii de potrivire',
    dateAgreed: 'Data convenită',
    test: 'Test',
    personalInformation: 'Date personale',
    walletInformation: 'Informații despre portofel',
    countryCity: 'Țară, oraș',
    mobile: 'Telefon mobil',
    documents: 'Documente',
    pendingFileGroups: 'Grupuri de fișiere în așteptare',
    verifiedWith: 'Verificat cu',
    validTill: 'Valid până la',
    uploadAsApproved: 'Încărca ca aprobat',
    archive: 'Arhivă',
    unverifyPlayerIdentity: 'Neverifica identitatea jucătorului',
    unverifyPlayerAddress: 'Anulează verificarea adresei jucătorului',
    fileNameAndExtension: 'Numele și extensia fișierului',
    approvedBy: 'Aprobat de',
    notBlacklisted: 'Neinclus pe lista neagră',
    statusBefore: 'Starea înainte',
    statusAfter: 'Starea după',
    currentStatus: 'Starea actuală',
    playersWithMissingInfo: 'Jucători cu informații incomplete',
    verifyDocumentInfo: 'Asigură-te că toate documentele aprobate conțin informații complete înainte de verificare.',
    notes: 'Note',
    markAttention: 'Semn de atenție',
    playerSession: 'Sesiune de jucător',
    playerBalance: 'Soldul jucătorului',
    playersBalance: 'Soldurile jucătorilor',
    testPlayersAccount: 'Cont de testare al jucătorului',
    accountUsersInformation: 'Informații despre contul de utilizator',
    process: 'Proces',
    attentionLevel: 'Nivelul de atenție',
    playerNotes: 'Notele jucătorului',
    cards: 'Carduri',
    sessionId: 'ID-ul sesiunii',
    sessionStart: 'Începutul sesiunii',
    sessionEnd: 'Sfârșitul sesiunii',
    sessionEndReason: 'Motivul încheierii sesiunii',
    walletTransactionId: 'ID-ul tranzacției de portofel',
    realWalletAfter: 'Portofel real după',
    sumRealWallets: 'Sumă de portofele reale',
    actionLogs: 'Jurnalele de acțiuni',
    day1HoursLimitAmount: 'Suma limită pentru 24 de ore',
    days7LimitAmount: 'Suma limită pentru 7 zile',
    month1LimitAmount: 'Suma limită pentru 1 lună',
    selectedProviders: 'Furnizori selectați',
    countryOfCitizenship: 'Țara de cetățenie',
    lCountryOfCitizenship: 'țara de origine',
    citizenshipVerified: 'Cetățenie verificată',
    blockProviders: 'Blochează furnizorii',
    blockedProvidersList: 'Lista de furnizori blocați',
    responsibleGamingLimits: 'Limite de joc responsabil',
    p2pGgr: 'P2P VBJ',
    pep: 'PEP',
    verticalCategoryNoReasonInfo: 'Te rugăm să activezi motivele pentru această categorie sau să modifici cerința de motive din categorie',
    clickToSeePendingFiles: 'Fă clic pe pictogramă pentru a vedea fișierele în așteptare',
    repetitionPeriod: 'Perioadă de repetare',
    subAffiliateId: 'ID subafiliat',
    repetitionDate: 'Data repetării',
    approvalDate: 'Data aprobării',
    debtWallet: 'Portofelul datoriei',
    betLimit: {
      modalTitle: 'Setare limită pariu',
      name: 'Limită pariu',
      description: 'Controlează banii pe care jucătorul îi cheltuiește pe jocurile de noroc',
      buttonText: 'Setare limită',
    },
    withdrawalLimit: {
      modalTitle: 'Setare limită retragere',
      name: 'Limită retragere',
      description: 'Controlează banii pe care jucătorul îi retrage',
      buttonText: 'Setare limită',
    },
    depositLimit: {
      modalTitle: 'Setare limită depunere',
      name: 'Limită depunere',
      description: 'Controlează banii pe care jucătorul îi depune pentru jocurile de noroc',
      buttonText: 'Setare limită',
    },
    timeOutLimit: {
      modalTitle: 'Setare time-out',
      name: 'Time-Out',
      description: 'Acordă jucătorilor o mică pauză de la toate activitățile legate de jocurile de noroc',
      buttonText: 'Setare time-out',
    },
    selfExclusionLimit: {
      modalTitle: 'Setare excludere',
      name: 'Atuoexcludere',
      description: 'Exclude jucătorul de la toate activitățile legate de jocurilor de noroc pentru a rămâne în control',
      buttonText: 'Setare excludere',
    },
    realityCheckLimit: {
      modalTitle: 'Setare verificare',
      name: 'Verificare realitate',
      description: 'Reamintește jucătorului timpul petrecut pe platformă',
      buttonText: 'Setare verificare',
    },
    accessLimit: {
      modalTitle: 'Setare limită acces',
      name: 'Limită acces',
      description: 'Limitează accesul jucătorului la website',
      buttonText: 'Setare limită',
    },
    lossLimit: {
      modalTitle: 'Setare limită pierdere',
      name: 'Limită de pierdere',
      description: 'Controlează banii pe care jucătorul îi pierde la jocurile de noroc',
      buttonText: 'Setare limită',
    },
    singleBetLimit: {
      modalTitle: 'Setarea limită pariu simplu',
      name: 'Limită pariu simplu',
      description: 'Controlează valoarea maximă a mizei simple pe care jucătorul o poate paria',
      buttonText: 'Setare limită',
    },
    gameTimeLimit: {
      modalTitle: 'Setare limită de timp pentru joc',
      name: 'Limită de timp pentru joc',
      description: 'Controlează timpul petrecut cu jocurile RNG.',
      buttonText: 'Setare limită',
    },
    personalNumericCode: 'Cod numeric personal',
    personalNumericCodeNote:
      'Dacă este bifat, câmpul cu codul numeric personal este adăugat la fluxul de verificare a documentelor, poate fi verificat cu „Document” și este disponibil în diferite rapoarte.',
    brandRealityCheckLimitInfo: 'Limita este configurată pentru toți jucătorii mărcii și nu este posibilă modificare limitei pentru un jucător individual',
    externalPlayerId: 'ID jucător extern',
    documentDescriptionInfo: 'Te rugăm să descrii semnificația documentului',
    realWalletBefore: 'Portofel real înainte',
    resetPassword: 'Resetare parolă',
    PlayerMobileNumberInUse: 'Există deja un jucător cu acest număr de telefon',
    PlayerEmailInUse: 'Există deja un jucător cu această adresă de e-mail',
    cpfNumber: 'Număr CPF',
    disableTFA: 'Dezactivare 2FA',
    tFA: '2FA',
    missingFieldsInAttachmentsInfo: 'Datele necesare pentru aprobarea documentului nu au fost completate',
    year1LimitAmount: 'Valoare limită pentru 1 an',
    pushNotification: 'Notificare Push',
    indicators: 'Indicatori',
    turnover: 'Cifră de rulat',
    totalNetBalance: 'Total sold net',
    extraWallets: 'Portofele extra',
    tillDate: 'Până la data',
    tillDateInfo: '„Până la data” poate conține o dată după cel puțin șapte zile de la data actuală.',
    currentType: 'Tip curent',
    upcomingType: 'Tip viitor',
    upcomingDate: 'Dată viitoare',
    editAccessLimit: 'Editare limită de acces',
    weekDays: 'Zile săptămână',
    inactivePeriodTime: 'Perioadă inactivă',
    setBy: 'Setat de',
    effectDate: 'Data efectivă',
    accessLimitTimezoneInfo: 'Limita de acces va funcționa cu fusul orar implicit al mărcii: {{timezone}}',
    upcoming: 'Viitor',
    viewAccessLimit: 'Vizualizare limită de acces',
    cpfNumberVerified: 'CPF verificat',
    deposit: 'Depunere',
    withdrawal: 'Retragere',
    smsPreferencesDescription: 'Selectează evenimentele pentru care jucătorul să primească o notificare prin SMS.',
    emailPreferencesDescription: 'Selectează evenimentele pentru care jucătorul să primească o notificare prin e-mail.',
    pushPreferencesDescription: 'Selectează evenimentele pentru care jucătorul să primească o notificare Push.',
    blockedPayments: 'Plăți blocate',
    blockPayments: 'Blocare plăți',
    unblockPayments: 'Deblocare plăți',
    endSessions: 'Încheiere sesiuni',
    showLastLoginInfo: 'Afișare ultimele date de conectare',
    showLastLoginInfoNote: 'Prin activare, jucătorul va vedea ultimele date de conectare pe site-ul web.',
    day1HoursTimeLimit: 'Limită de timp de 24 de ore',
    days7TimeLimit: 'Limită de timp de 7 zile',
    month1TimeLimit: 'Limită de timp de 1 lună',
    year1TimeLimit: 'Limită de timp de 1 an',
    noExpiry: 'Fără expirare',
    documentNoExpiryDateInfo: 'Prin activarea acestei opțiuni, documentul nu va avea o dată de expirare.',
    taxSessionID: 'ID sesiune impozitare',
    taxSessionStart: 'Începutul sesiunii de impozitare',
    taxSessionEnd: 'Sfârșitul sesiunii de impozitare',
    blockedDepositUntil: 'Depunere blocată până la {{data}}',
    blockedWithdrawalUntil: 'Retragere blocată până la {{data}}',
    paymentVerified: 'Plată verificată',
    fullVerified: 'Verificată complet',
    allowedAttachmentsCountInfo: 'Pentru tipul de documente selectat, trebuie încărcat(e) {{număr}} atașament(e)',
    dailyLimitAmount: 'Suma limită pentru o zi',
    weeklyLimitAmount: 'Suma limită pentru o săptămână',
    monthlyLimitAmount: 'Suma limită pentru o lună',
    annualLimitAmount: 'Suma limită pentru un an',
    eddVerified: 'Edd verificat',
    enhancedDueDiligence: 'Proces de diligență îmbunătățit (edd)',
    setPlayerOTPInfo: 'OTP rămâne vizibil până când jucătorul își schimbă parola, apoi este eliminat automat. Poți genera oricând un nou OTP, dacă este necesar.',
    oneTimePassword: 'Parolă unică',
    setOTP: 'Setează OTP',
    legacyData: 'Date istorice',
    dailyLimit: 'Limită zilnică',
    day1HoursLimit: 'Limită de 24 de ore',
    weeklyLimit: 'Limită săptămânală',
    days7Limit: 'Termen de 7 zile',
    monthlyLimit: 'Limită lunară',
    month1Limit: 'Limită de 1 lună',
    annualLimit: 'Limită anuală',
    year1Limit: 'Limită de 1 an',
    dateOfBirthDate: 'Data nașterii: Dată',
    dateOfBirthMonth: 'Data nașterii: Lună',
    personal: 'Personal',
    wallet: 'Portofel',
    docs: 'Documente',
    changeLayout: 'Modificare aspect',
    top: 'Top',
    left: 'Stânga',
    right: 'Dreapta',
    accumulatedTax: 'Impozit acumulat',
    numberOfLevel: 'Nivelul {{number}}',
    sportOpenBets: 'Pariuri deschise pe sport',
    unblockPayment: 'Deblocare plată',
    otp: 'OTP',
    generate: 'Generare',
    regenerate: 'Regenerare',
    addNewNote: 'Adăugare notă nouă',
    lastTrigger24HoursLimitAmount: 'Sumă limită pentru ultimul declanșator de 24 de ore',
    lastTrigger7DaysLimitAmount: 'Sumă limită pentru ultimul declanșator de 7 zile',
    lastTrigger1MonthLimitAmount: 'Sumă limită pentru ultimul declanșator de 1 lună',
    lastTrigger1YearLimitAmount: 'Sumă limită pentru ultimul declanșator de 1 an',
    paydromAccount: 'Cont Paydrom',
    episServersDownInfo: 'Serverele EPIS nu răspund',
    placeOfIssue: 'Locul emiterii',
    choosePlaceOfIssue: 'Alegeți locul emiterii',
    months: 'Luni',
    episVerified: 'Verificat de EPIS',
    episNotVerified: 'Neverificat de EPIS',
    rutNumber: 'Număr RUT',
  },
  bg: {},
  el: {
    identityVerified: 'Επαληθευμένη ταυτότητα',
    emailVerified: 'Επαληθευμένο email',
    mobileVerified: 'Επαληθευμένο κινητό',
    addressVerified: 'Επαληθευμένη διεύθυνση',
    accountLocked: 'Ο λογαριασμός είναι κλειδωμένος',
    locked: 'Κλειδωμένος',
    accountInactive: 'Ο λογαριασμός είναι ανενεργός',
    blockedForMessages: 'Αποκλείστηκε για μηνύματα',
    closed: 'Κλειστό',
    inactiveAccount: 'Ανενεργός λογαριασμός',
    accountInTimeout: 'Ο λογαριασμός βρίσκεται σε προσωρινή διακοπή',
    accountSelfExcluded: 'Ο λογαριασμός βρίσκεται υπό αυτοαποκλεισμό',
    exclusionState: 'Κατάσταση αποκλεισμού',
    physicalVerification: 'Φυσική επαλήθευση',
    blacklisted: 'Βρίσκεται στη λίστα αποκλεισμένων',
    regDate: 'Ημερομηνία εγγραφής',
    regIP: 'IP εγγραφής',
    emailNotifications: 'Ειδοποιήσεις email',
    SMSNotifications: 'Ειδοποιήσεις SMS',
    accountType: 'Τύπος λογαριασμού',
    accountUsers: 'Χρήστες λογαριασμού',
    lastProvisionDate: 'Ημερομηνία τελευταίας παροχής',
    lastAdjustmentDate: 'Ημερομηνία τελευταίας προσαρμογής',
    currencyDeletedOrDisabledTooltip: 'Το νόμισμα λογαριασμού ενδέχεται να έχει απενεργοποιηθεί/διαγραφεί',
    adjustBalance: 'Προσαρμογή υπολοίπου',
    finishUse: 'Τέλος χρήσης',
    closedAccountNote: 'Ο λογαριασμός θα κλείσει και δεν θα είναι πλέον διαθέσιμος.',
    freeAccountNote: 'Ο λογαριασμός θα είναι ελεύθερος για χρήση.',
    testAccountDetails: 'Στοιχεία δοκιμαστικού λογαριασμού',
    userDetails: 'Στοιχεία χρήστη',
    accountUser: 'Χρήστης λογαριασμού',
    userEmail: 'Email χρήστη',
    userEmailTooltip: 'Τα στοιχεία πρόσβασης του λογαριασμού θα σταλούν στο email που έχετε δώσει',
    adjust: 'Προσαρμογή',
    moneyTransferred: 'Χρήματα που μεταφέρθηκαν',
    moneyUsed: 'Χρήματα που χρησιμοποιήθηκαν',
    provisionDate: 'Ημερομηνία παροχής',
    providedBy: 'Παροχή από',
    attachmentId: 'Αναγνωριστικό συνημμένου',
    startProcess: 'Έναρξη διαδικασίας',
    manageFiles: 'Διαχείριση αρχείων',
    blockControl: 'Έλεγχος αποκλεισμού',
    unblockMessages: 'Αναίρεση αποκλεισμού μηνυμάτων',
    investigationResults: 'Αποτελέσματα έρευνας',
    noAvailableAccountInfo: 'Ο λογαριασμός δεν θα είναι πλέον διαθέσιμος για χρήση.',
    lComplete: 'ολοκληρωμένο',
    lIncomplete: 'μη ολοκληρωμένο',
    accountVerificationProgress: 'Πρόοδος επαλήθευσης λογαριασμού',
    newslettersAndPromotions: 'Ενημερωτικά δελτία και προωθητικές ενέργειες',
    betLimit: {
      modalTitle: 'Ρύθμιση ορίου στοιχήματος',
      name: 'Όριο στοιχήματος',
      description: 'Έλεγχος των χρημάτων που ξοδεύει ο παίκτης σε τυχερά παιχνίδια',
      buttonText: 'Ρύθμιση ορίου',
    },
    withdrawalLimit: {
      modalTitle: 'Ρύθμιση ορίου ανάληψης',
      name: 'Όριο ανάληψης',
      description: 'Έλεγχος των χρημάτων ανάληψης παίκτη',
      buttonText: 'Ρύθμιση ορίου',
    },
    depositLimit: {
      modalTitle: 'Ρύθμιση ορίου κατάθεσης',
      name: 'Όριο κατάθεσης',
      description: 'Έλεγχος των χρημάτων που καταθέτει ο παίκτης για συμμετοχή σε τυχερά παιχνίδια',
      buttonText: 'Ρύθμιση ορίου',
    },
    timeOutLimit: {
      modalTitle: 'Ρύθμιση προσωρινής διακοπής',
      name: 'Προσωρινή διακοπή',
      description: 'Δίνει στον παίκτη την ευκαιρία να απέχει για ένα σύντομο χρονικό διάστημα από όλες τις δραστηριότητες τυχερών παιχνιδιών',
      buttonText: 'Ρύθμιση προσωρινής διακοπής',
    },
    selfExclusionLimit: {
      modalTitle: 'Set Exclusion',
      name: 'Αυτοαποκλεισμός',
      description: 'Αποκλείει τον παίκτη από όλες τις δραστηριότητες τυχερών παιχνιδιών, ώστε να διατηρεί τον έλεγχο',
      buttonText: 'Ορισμός αποκλεισμού',
    },
    realityCheckLimit: {
      modalTitle: 'Ρύθμιση ελέγχου',
      name: 'Reality Check',
      description: 'Υπενθυμίζει στον παίκτη πόσο χρόνο έχει περάσει στην πλατφόρμα',
      buttonText: 'Ρύθμιση ελέγχου',
    },
    accessLimit: {
      modalTitle: 'Ρύθμιση ορίου πρόσβασης',
      name: 'Όριο πρόσβασης',
      description: 'Περιορίστε την πρόσβαση του παίκτη στον ιστότοπο',
      buttonText: 'Ρύθμιση ορίου',
    },
    lossLimit: {
      modalTitle: 'Ρύθμιση ορίου απωλειών',
      name: 'Όριο απωλειών',
      description: 'Ελέγχει τα χρήματα που χάνει ο παίκτης κατά τη συμμετοχή του στα τυχερά παιχνίδια',
      buttonText: 'Ρύθμιση ορίου',
    },
    singleBetLimit: {
      modalTitle: 'Ρύθμιση ορίου μονών στοιχημάτων',
      name: 'Όριο μονών στοιχημάτων',
      description: 'Ελέγχει το μέγιστο μεμονωμένο ποντάρισμα που μπορεί να τοποθετήσει ο παίκτης',
      buttonText: 'Ορισμός ορίου',
    },
    gameTimeLimit: {
      modalTitle: 'Ορισμός ορίου χρόνου παιχνιδιού',
      name: 'Όριο χρόνου παιχνιδιού',
      description: 'Ελέγχει τον χρόνο που αφιερώσατε σε παιχνίδια με γεννήτρια τυχαίων αριθμών (RNG)',
      buttonText: 'Ορισμός ορίου',
    },
    noLimit: 'Χωρίς Όριο',
    current: 'Τρέχον',
    remainder: 'Απομένει',
    upcomingChanges: 'Επερχόμενες αλλαγές',
    limitType: 'Τύπος ορίου',
    endOfLimitation: 'Τέλος περιορισμού',
    appliedBy: 'Εφαρμόστηκε από',
    exportNoteInfo: 'Θα εξάγονται δεδομένα μέχρι 6 μηνών.',
    accountStatusBeforeClosure: 'Κατάσταση λογαριασμού πριν από το κλείσιμο',
    accountRegistrationDate: 'Ημερομηνία εγγραφής λογαριασμού',
    accountClosureDate: 'Ημερομηνία κλεισίματος λογαριασμού',
    reasonOfClosure: 'Αιτία κλεισίματος',
    matchingCriteria: 'Κριτήρια αντιστοίχισης',
    dateAgreed: 'Ημερομηνία συμφωνίας',
    test: 'Δοκιμαστικός',
    personalInformation: 'Προσωπικά στοιχεία',
    walletInformation: 'Στοιχεία πορτοφολιού',
    countryCity: 'Χώρα, πόλη',
    mobile: 'Κινητό',
    documents: 'Έγγραφα',
    pendingFileGroups: 'Ομάδες αρχείων σε εκκρεμότητα',
    verifiedWith: 'Επαληθεύτηκε με',
    uploadAsApproved: 'Μεταφόρτωση ως εγκεκριμένο',
    archive: 'Αρχειοθέτηση',
    unverifyPlayerIdentity: 'Αναίρεση επαλήθευσης ταυτότητας παίκτη',
    unverifyPlayerAddress: 'Αναίρεση επαλήθευσης διεύθυνσης παίκτη',
    fileNameAndExtension: 'Όνομα και επέκταση αρχείου',
    approvedBy: 'Εγκρίθηκε από',
    notBlacklisted: 'Δεν βρίσκεται στη λίστα αποκλεισμένων',
    statusBefore: 'Κατάσταση πριν',
    statusAfter: 'Κατάσταση μετά',
    currentStatus: 'Τρέχουσα κατάσταση',
    playersWithMissingInfo: 'Παίκτες με ελλιπή στοιχεία',
    verifyDocumentInfo: 'Βεβαιωθείτε ότι τα στοιχεία που περιέχονται σε όλα τα εγκεκριμένα έγγραφα είναι πλήρη πριν από την επαλήθευση.',
    notes: 'Σημειώσεις',
    markAttention: 'Επισήμανση προσοχής',
    playerSession: 'Συνεδρία παίκτη',
    playerBalance: 'Υπόλοιπο παίκτη',
    playersBalance: 'Υπόλοιπα παικτών',
    testPlayersAccount: 'Δοκιμαστικός λογαριασμός παίκτη',
    accountUsersInformation: 'Στοιχεία χρήστη λογαριασμού',
    process: 'Επεξεργασία',
    attentionLevel: 'Επίπεδο προσοχής',
    playerNotes: 'Σημειώσεις παίκτη',
    cards: 'Κάρτες',
    sessionId: 'Αναγνωριστικό συνεδρίας',
    sessionStart: 'Έναρξη συνεδρίας',
    sessionEnd: 'Λήξη συνεδρίας',
    sessionEndReason: 'Αιτία λήξης συνεδρίας',
    walletTransactionId: 'Αναγνωριστικό συναλ. πορτοφολιού',
    realWalletAfter: 'Πορτοφόλι πραγματικών χρημάτων μετά',
    sumRealWallets: 'Ποσό πορτοφολιών πραγματικών χρημάτων',
    actionLogs: 'Αρχεία καταγραφής ενεργειών',
    day1HoursLimitAmount: 'Ποσό ορίου 24 ωρών',
    days7LimitAmount: 'Ποσό ορίου 7 ημερών',
    month1LimitAmount: 'Ποσό ορίου 1 μήνα',
    selectedProviders: 'Επιλεγμένοι πάροχοι',
    countryOfCitizenship: 'Χώρα υπηκοότητας',
    lCountryOfCitizenship: 'χώρα υπηκοότητας',
    citizenshipVerified: 'Επαληθευμένη υπηκοότητα',
    blockProviders: 'Αποκλεισμός παρόχων',
    blockedProvidersList: 'Λίστα αποκλεισμένων παρόχων',
    blockedProviders: 'Αποκλεισμένοι πάροχοι',
    lastDeposit: 'Τελευταία κατάθεση',
    lastWithdrawal: 'Τελευταία ανάληψη',
    last24hDeposits: 'Καταθέσεις εντός των τελευταίων 24 ωρών',
    last24hWithdrawals: 'Αναλήψεις εντός των τελευταίων 24 ωρών',
    takenMonthData: 'Λαμβάνονται υπόψη μόνο δεδομένα από τους τελευταίους {{count}} μήνες',
    method: 'Μέθοδος',
    playerActivities: 'Δραστηριότητες παίκτη',
    lastLoginInfo: 'Στοιχεία τελευταίας σύνδεσης',
    registrationInfo: 'Πληροφορίες εγγραφής',
    responsibleGamingLimits: 'Όρια υπεύθυνου παιχνιδιού',
    p2pGgr: 'GGR από P2P',
    pep: 'PEP',
    verticalCategoryNoReasonInfo: 'Ενεργοποιήστε τις αιτίες για αυτή την κατηγορία ή επεξεργαστείτε το προαπαιτούμενο αιτιών από αυτή την κατηγορία',
    clickToSeePendingFiles: 'Κάντε κλικ στο εικονίδιο για να δείτε τα αρχεία που είναι σε εκκρεμότητα',
    repetitionPeriod: 'Περίοδος επανάληψης',
    subAffiliateId: 'Αναγνωριστικό υποσυνεργάτη',
    repetitionDate: 'Ημερομηνία επανάληψης',
    approvalDate: 'Ημερομηνία έγκρισης',
    debtWallet: 'Πορτοφόλι οφειλών',
    personalNumericCode: 'Προσωπικός αριθμητικός κωδικός',
    personalNumericCodeNote:
      'Αν είναι επιλεγμένο, το πεδίο Προσωπικού αριθμητικού κωδικού προστίθεται στη ροή Επαλήθευσης εγγράφων, μπορεί να επαληθευτεί με Έγγραφο και είναι διαθέσιμο σε διάφορες αναφορές.',
    brandRealityCheckLimitInfo: 'Το όριο διαμορφώνεται για όλους τους παίκτες της επωνυμίας και δεν μπορεί να αλλάξει για τον παίκτη προσωπικά',
    externalPlayerId: 'Εξωτερικό αναγνωριστικό παίκτη',
    documentDescriptionInfo: 'Περιγράψτε το έγγραφο',
    realWalletBefore: 'Πορτοφόλι πραγματικών χρημάτων πριν',
    resetPassword: 'Επαναφορά κωδικού πρόσβασης',
    PlayerMobileNumberInUse: 'Υπάρχει ήδη παίκτης με αυτόν τον αριθμό τηλεφώνου',
    PlayerEmailInUse: 'Υπάρχει ήδη παίκτης με αυτή τη διεύθυνση email',
    cpfNumber: 'Αριθμός CPF',
    disableTFA: 'Απενεργοποίηση 2FA',
    tFA: '2FA',
    missingFieldsInAttachmentsInfo: 'Δεν έχουν υποβληθεί τα απαιτούμενα δεδομένα για την έγκριση αυτού του εγγράφου',
    year1LimitAmount: 'Ποσό ορίου 1 έτους',
    pushNotification: 'Ειδοποίηση push',
    indicators: 'Δείκτες',
    turnover: 'Τζιράρισμα',
    totalNetBalance: 'Συνολικό καθαρό υπόλοιπο',
    extraWallets: 'Επιπλέον πορτοφόλια',
    tillDate: 'Μέχρι την ημερομηνία',
    tillDateInfo: 'Το «Μέχρι την ημερομηνία» μπορεί να επιλεγεί τουλάχιστον επτά ημέρες μετά την παρούσα ημερομηνία',
    currentType: 'Τρέχων τύπος',
    upcomingType: 'Προσεχής τύπος',
    upcomingDate: 'Προσεχής ημερομηνία',
    editAccessLimit: 'Επεξεργασία ορίου πρόσβασης',
    weekDays: 'Καθημερινές',
    inactivePeriodTime: 'Χρόνος ανενεργής περιόδου',
    setBy: 'Ορίστηκε από',
    effectDate: 'Ημερομηνία ισχύος',
    accessLimitTimezoneInfo: 'Το όριο πρόσβασης θα λειτουργεί με την προεπιλεγμένη ζώνη ώρας της επωνυμίας: {{timezone}}',
    upcoming: 'Προσεχές',
    viewAccessLimit: 'Προβολή ορίου πρόσβασης',
    cpfNumberVerified: 'Επαληθευμένο CPF',
    deposit: 'Κατάθεση',
    withdrawal: 'Ανάληψη',
    smsPreferencesDescription: 'Επιλέξτε τα γεγονότα για τα οποία ο παίκτης θα λαμβάνει ειδοποιήσεις SMS.',
    emailPreferencesDescription: 'Επιλέξτε τα γεγονότα για τα οποία ο παίκτης θα λαμβάνει ειδοποιήσεις email.',
    pushPreferencesDescription: 'Επιλέξτε τα γεγονότα για τα οποία ο παίκτης θα λαμβάνει ειδοποιήσεις push.',
    blockedPayments: 'Αποκλεισμένες πληρωμές',
    blockPayments: 'Αποκλεισμός πληρωμών',
    unblockPayments: 'Κατάργηση αποκλεισμού πληρωμών',
    endSessions: 'Τέλος συνεδριών',
    showLastLoginInfo: 'Προβολή στοιχείων τελευταίας σύνδεσης',
    showLastLoginInfoNote: 'Ενεργοποιώντας το, ο παίκτης θα δει τα τελευταία στοιχεία σύνδεσης στον ιστότοπο.',
    day1HoursTimeLimit: 'Χρονικό όριο 24 ωρών',
    days7TimeLimit: 'Χρονικό όριο 7 ημερών',
    month1TimeLimit: 'Χρονικό όριο 1 μήνα',
    year1TimeLimit: 'Χρονικό όριο 1 έτους',
    noExpiry: 'Χωρίς λήξη',
    documentNoExpiryDateInfo: 'Αν το ενεργοποιήσετε, το έγγραφο δεν θα έχει ημερομηνία λήξης.',
    taxSessionID: 'Αναγνωριστικό φορολογικής συνεδρίας',
    taxSessionStart: 'Έναρξη φορολογικής συνεδρίας',
    taxSessionEnd: 'Λήξη φορολογικής συνεδρίας',
    blockedDepositUntil: 'Αποκλεισμένη κατάθεση μέχρι {{date}}',
    blockedWithdrawalUntil: 'Αποκλεισμένη ανάληψη μέχρι {{date}}',
    paymentVerified: 'Η πληρωμή επαληθεύτηκε',
    fullVerified: 'Πλήρης επαλήθευση',
    allowedAttachmentsCountInfo: 'Για τον επιλεγμένο τύπο εγγράφου πρέπει να γίνει μεταφόρτωση {{count}} συνημμένων',
    dailyLimitAmount: 'Ημερήσιο ποσό ορίου',
    weeklyLimitAmount: 'Εβδομαδιαίο ποσό ορίου',
    monthlyLimitAmount: 'Μηνιαίο ποσό ορίου',
    annualLimitAmount: 'Ετήσιο ποσό ορίου',
    eddVerified: 'Eπαληθευμένο Edd',
    enhancedDueDiligence: 'Ενισχυμένη δέουσα επιμέλεια',
    setOTP: 'Ορισμός OTP',
    setPlayerOTPInfo: 'Το OTP παραμένει ορατό μέχρι ο παίκτης να αλλάξει τον κωδικό πρόσβασής του και στη συνέχεια αφαιρείται αυτόματα. Μπορείτε να δημιουργήσετε ένα νέο OTP οποιαδήποτε στιγμή, αν χρειάζεται.',
    oneTimePassword: 'Κωδικός μιας χρήσης',
    legacyData: 'Παλαιά δεδομένα',
    dailyLimit: 'Ημερήσιο όριο',
    day1HoursLimit: 'Όριο 24 ωρών',
    weeklyLimit: 'Εβδομαδιαίο όριο',
    days7Limit: 'Όριο 7 ημερών',
    monthlyLimit: 'Μηνιαίο όριο',
    month1Limit: 'Όριο 1 μήνα',
    annualLimit: 'Ετήσιο όριο',
    year1Limit: 'Όριο 1 έτους',
    dateOfBirthDate: 'Ημερομηνία γέννησης: Ημερομηνία',
    dateOfBirthMonth: 'Ημερομηνία γέννησης: Μήνας',
    personal: 'Προσωπικό',
    wallet: 'Πορτοφόλι',
    docs: 'Έγγραφα',
    changeLayout: 'Αλλαγή διάταξης',
    top: 'Κορυφή',
    left: 'Αριστερά',
    right: 'Δεξιά',
    accumulatedTax: 'Συσσωρευμένος φόρος',
    numberOfLevel: 'Επίπεδο {{number}}',
    sportOpenBets: 'Ενεργά πονταρίσματα για αθλήματα',
    unblockPayment: 'Ξεκλείδωμα πληρωμής',
    otp: 'OTP',
    generate: 'Δημιουργία',
    regenerate: 'Επανάληψη',
    addNewNote: 'Προσθήκη νέας σημείωσης',
    lastTrigger24HoursLimitAmount: 'Τελευταία ενεργοποίηση: Ποσό ορίου 24 ωρών',
    lastTrigger7DaysLimitAmount: 'Τελευταία ενεργοποίηση: Ποσό ορίου 7 ημερών',
    lastTrigger1MonthLimitAmount: 'Τελευταία ενεργοποίηση: Ποσό ορίου 1 μήνα',
    lastTrigger1YearLimitAmount: 'Τελευταία ενεργοποίηση: Ποσό ορίου 1 έτους',
    paydromAccount: 'Λογαριασμός Paydrom',
    episServersDownInfo: 'Οι διακομιστές EPIS δεν ανταποκρίνονται',
    placeOfIssue: 'Τόπος έκδοσης',
    choosePlaceOfIssue: 'Επιλογή τόπου έκδοσης',
    months: 'Μήνες',
    episVerified: 'Έχει επαληθευτεί από το EPIS',
    episNotVerified: 'EPIS: Δεν έχει επαληθευτεί',
    rutNumber: 'Αριθμός RUT',
  },
};
